// @ts-nocheck
/* eslint-disable */
import React, { useMemo, useEffect, useState } from 'react';
import useAppStore, { useCalculationsSelector, GesamtleistungMonatData, UrlaubsverlustData, MitarbeiterStatus, EmployeeData, MitarbeiterLeistungData } from '../store/appStore';
import { useShallow } from 'zustand/react/shallow';
import PasswordPromptModal from '../components/PasswordPrompt';
import EditableField from '../components/EditableField';
import { db, auth } from '../config/firebase';
import { doc, onSnapshot, DocumentData } from 'firebase/firestore';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import useAdminStore from '../store/adminStore';
import ExecutiveSummaryModalGesamt from '../components/ExecutiveSummaryModalGesamt'; 
import H1H2ComparisonModal, { type H1H2HalfMetrics, type H1H2AmpelStatus } from '../components/gesamtleistung/H1H2ComparisonModal';
import { evaluateRentabilitaet } from '../store/utils';
import { isSoloModeActive } from '../utils/soloMode';
import { TeamBonusPreviewPanel } from '../components/teamBonus';
import { isHj1ClientLocked } from '../utils/hjLock';
import Hj1MandantLockBanner from '../components/Hj1MandantLockBanner';

// ============================================================================
// STYLES: EXECUTIVE CARBON EDITION (NOBLE SLATE v11.0)
// ============================================================================
const DashboardStyles = () => (
    <style>{`
        @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;700;800&family=Inter:wght@300;400;600;800&display=swap');

        html, body {
            background-color: #030303 !important;
            margin: 0;
            padding: 0;
        }
        html:not(.dark), html:not(.dark) body {
            background-color: #F4F2EF !important;
        }

        .font-sans { font-family: 'Inter', sans-serif; }
        .font-mono-numbers { font-family: 'JetBrains Mono', monospace; font-variant-numeric: tabular-nums; }
        
        .bg-deep-space { background-color: #030303; }
        html:not(.dark) .bg-deep-space { background-color: var(--pe-bg-primary); }
        html:not(.dark) .carbon-weave-bg { background-color: var(--pe-bg-elevated); background-image: none; }
        html:not(.dark) .carbon-panel { background-color: var(--pe-bg-card); border-color: var(--pe-border-subtle); }
        html:not(.dark) .carbon-panel::after { background: none; }
        html:not(.dark) .bg-deep-space { background-color: var(--pe-bg-primary); }
        .text-phantom-gold { color: #E6C299; }
        html:not(.dark) .text-phantom-gold { color: var(--pe-accent-text); }
        
        .carbon-weave-bg {
            background-color: #111;
            background-image: 
                radial-gradient(circle at 100% 150%, #111 24%, #1a1a1a 24%, #1a1a1a 28%, #111 28%, #111 36%, #1a1a1a 36%, #1a1a1a 40%, transparent 40%, transparent),
                radial-gradient(circle at 0 150%, #111 24%, #1a1a1a 24%, #1a1a1a 28%, #111 28%, #111 36%, #1a1a1a 36%, #1a1a1a 40%, transparent 40%, transparent),
                radial-gradient(circle at 50% 100%, #1a1a1a 10%, #111 10%, #111 23%, #1a1a1a 23%, #1a1a1a 30%, #111 30%, #111 43%, #1a1a1a 43%, #1a1a1a 50%, #111 50%, #111 63%, #1a1a1a 63%, #1a1a1a 71%, transparent 71%, transparent),
                radial-gradient(circle at 100% 50%, #1a1a1a 5%, #111 5%, #111 15%, #1a1a1a 15%, #1a1a1a 20%, #111 20%, #111 29%, #1a1a1a 29%, #1a1a1a 34%, #111 34%, #111 44%, #1a1a1a 44%, #1a1a1a 49%, transparent 49%, transparent),
                radial-gradient(circle at 0 50%, #1a1a1a 5%, #111 5%, #111 15%, #1a1a1a 15%, #1a1a1a 20%, #111 20%, #111 29%, #1a1a1a 29%, #1a1a1a 34%, #111 34%, #111 44%, #1a1a1a 44%, #1a1a1a 49%, transparent 49%, transparent);
            background-size: 20px 20px;
        }

        .carbon-console, .carbon-panel {
            position: relative;
            border-radius: 1.5rem;
            border: 1px solid #2a2a2a;
            box-shadow: 0 30px 60px -15px rgba(0,0,0,1), inset 0 2px 5px rgba(255,255,255,0.05);
            background-color: #111111;
        }

        .carbon-console::after, .carbon-panel::after {
            content: ''; position: absolute; inset: 0; background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.6)); border-radius: inherit; pointer-events: none;
        }

        .carbon-content { position: relative; z-index: 10; }

        html:not(.dark) .carbon-weave-bg {
            background-image: none;
            background-color: #FAF9F7;
        }
        html:not(.dark) .carbon-console,
        html:not(.dark) .carbon-panel {
            border: 1px solid #D6D3D1;
            box-shadow: 0 12px 28px -12px rgba(28, 25, 23, 0.18);
            background-color: #FFFFFF;
        }
        html:not(.dark) .carbon-console::after,
        html:not(.dark) .carbon-panel::after {
            background: none;
        }
        html:not(.dark) .metal-badge {
            background: linear-gradient(to bottom, #FAF9F7, #EDEAE6);
            border: 1px solid #D6D3D1;
            box-shadow: inset 0 1px 0 rgba(255,255,255,0.8), 0 2px 6px rgba(28,25,23,0.06);
        }

        /* NEON LED COLORS */
        .led-purple  { color: #c084fc; text-shadow: 0 0 10px rgba(192,132,252,0.6), 0 0 20px rgba(192,132,252,0.3); }
        .led-emerald { color: #10b981; text-shadow: 0 0 10px rgba(16,185,129,0.6), 0 0 20px rgba(16,185,129,0.3); }
        .led-lime    { color: #a3e635; text-shadow: 0 0 10px rgba(163,230,53,0.6),  0 0 20px rgba(163,230,53,0.3); }
        .led-amber   { color: #fbbf24; text-shadow: 0 0 10px rgba(251,191,36,0.6),  0 0 20px rgba(251,191,36,0.3); }
        .led-orange  { color: #fb923c; text-shadow: 0 0 10px rgba(251,146,60,0.6),  0 0 20px rgba(251,146,60,0.3); }
        .led-red     { color: #ef4444; text-shadow: 0 0 10px rgba(239,68,68,0.6),   0 0 20px rgba(239,68,68,0.3); }
        .led-gold    { color: #E6C299; text-shadow: 0 0 10px rgba(230,194,153,0.6), 0 0 20px rgba(230,194,153,0.3); }
        .led-white   { color: #fff; text-shadow: 0 0 15px rgba(255,255,255,0.5); }

        /* LIGHT-MODE: LED-Farben abgedunkelt, ohne Glow (Dark bleibt unangetastet) */
        html:not(.dark) .led-purple  { color: #6D28D9; text-shadow: none; }
        html:not(.dark) .led-emerald { color: #047857; text-shadow: none; }
        html:not(.dark) .led-lime    { color: #4D7C0F; text-shadow: none; }
        html:not(.dark) .led-amber   { color: #B45309; text-shadow: none; }
        html:not(.dark) .led-orange  { color: #C2410C; text-shadow: none; }
        html:not(.dark) .led-red     { color: #B91C1C; text-shadow: none; }
        html:not(.dark) .led-gold    { color: var(--pe-accent-text); text-shadow: none; }
        html:not(.dark) .led-white   { color: #1C1917; text-shadow: none; }

        .metal-badge {
            background: linear-gradient(to bottom, #222, #0a0a0a);
            border: 1px solid #333;
            box-shadow: inset 0 1px 0 rgba(255,255,255,0.1), 0 4px 10px rgba(0,0,0,0.8);
            border-radius: 6px;
        }

        /* Feste Seiten-Scrollbar (sichtbar) — #app-main-scroll ist global ausgeblendet */
        #main-scroll-container {
            scrollbar-width: thin;
            scrollbar-color: #E6C299 #0a0a0a;
        }
        #main-scroll-container::-webkit-scrollbar {
            height: 14px;
            width: 14px;
        }
        #main-scroll-container::-webkit-scrollbar-track {
            background: #0a0a0a;
        }
        #main-scroll-container::-webkit-scrollbar-thumb {
            background: #E6C299;
            border-radius: 4px;
            border: 2px solid #0a0a0a;
        }
        #main-scroll-container::-webkit-scrollbar-thumb:hover {
            background: #f0d4b0;
        }
    `}</style>
);

const FESTMACHEN_PASSWORT = '90';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SafePasswordPrompt = PasswordPromptModal as any;

const PAUSCHAL_FEIERTAGE = 11;
const monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

const vorjahresDatenLeer = Array(12).fill(null).map(() => ({
    vorjahrWert1: 0,
    vorjahrWert2: 0,
    vorjahrProzent: 0
}));

const safeDiv = (numerator: number, denominator: number) => {
    const num = Number(numerator);
    const den = Number(denominator);
    if (!den || isNaN(num) || isNaN(den)) return 0;
    return num / denominator;
};

const formatValueOnly = (value: number, decimalPlaces = 0) => {
    return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
        useGrouping: true
    }).format(value || 0);
};

const formatCurrencyString = (value: number, currency: string = 'EUR') => {
    return formatValueOnly(value, 0) + ' ' + currency;
};

const formatNumber = (value: number, decimalPlaces = 1, suffix = '') => {
    const num = Number(value);
    if (isNaN(num)) return '-';
    return num.toLocaleString('de-DE', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    }) + (suffix ? ` ${suffix}` : '');
};

const formatPercentage = (value: number, decimalPlaces = 1) => {
    const num = Number(value);
    if (isNaN(num)) return '-';
    return (num * 100).toLocaleString('de-DE', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    }) + '%';
};

// ============================================================================
// WERKZEUG-KOMPONENTEN
// ============================================================================

const RealRentabilitaetCard: React.FC<{ 
    rentabilitaet: number, 
    inhaberErtrag: number, 
    istUmsatzNetto: number, 
    currency: string,
    gehalt: number,
    ueberschussProzent: number
}> = ({ rentabilitaet, inhaberErtrag, istUmsatzNetto, currency, gehalt, ueberschussProzent }) => {
    
    if (istUmsatzNetto <= 0) {
        return (
            <div className="w-full border-2 border-dashed border-pe-border-strong bg-pe-elevated rounded-xl p-6 flex items-center justify-center mt-4">
                <p className="text-slate-500 font-sans text-sm italic">
                    Trage Umsätze in die Tabelle ein, um deine reale Rentabilität zu berechnen.
                </p>
            </div>
        );
    }

    const getStatus = () => {
        const evalResult = evaluateRentabilitaet(gehalt, ueberschussProzent);
        
        let fallbackText = "";
        switch (evalResult.status) {
            case 'Exzellent': 
                fallbackText = "Hervorragende Rentabilität. Das absolute Gehalt und der Überschuss sind zukunftssicher.";
                return { color: 'text-purple-400 led-purple', border: 'border-purple-500/30', label: 'EXZELLENT', text: evalResult.text || fallbackText };
            case 'Gut': 
                fallbackText = "Gute Rentabilität. Das Gehalt und der Überschuss bilden ein gesundes Fundament.";
                return { color: 'text-emerald-400 led-emerald', border: 'border-emerald-500/30', label: 'GUT', text: evalResult.text || fallbackText };
            case 'Solide': 
                fallbackText = "Solide Rentabilität. Das Geschäft trägt sich gut, bietet aber noch Optimierungspotenzial.";
                return { color: 'text-lime-400 led-lime', border: 'border-lime-500/30', label: 'SOLIDE', text: evalResult.text || fallbackText };
            case 'Grenzwertig': 
                fallbackText = "Grenzwertige Rentabilität. Der Überschuss oder das Gehalt ist zu niedrig für langfristige Sicherheit.";
                return { color: 'text-amber-400 led-amber', border: 'border-amber-500/30', label: 'GRENZWERTIG', text: evalResult.text || fallbackText };
            case 'Kritisch': 
            default: 
                fallbackText = "Veto-Auslösung: Kritischer Zustand. Weder das absolute Gehalt noch der Überschuss sind tragfähig.";
                return { color: 'text-red-400 led-red', border: 'border-red-500/30', label: evalResult.status === 'Kritisch' ? 'KRITISCH' : 'KRITISCH BIS INSTABIL', text: evalResult.text || fallbackText };
        }
    };

    const status = getStatus();

    return (
        <div className="w-full mt-4 animate-in fade-in duration-500 carbon-panel border border-pe-border-strong overflow-hidden bg-pe-card dark:bg-[#030303]" data-tooltip-id="app-tooltip" data-tooltip-content="Zeigt das Verhältnis zwischen deinem Gewinn und dem erwirtschafteten Nettoumsatz an.">
            <div className={`carbon-content flex items-center justify-between border-b ${status.border} p-4 shadow-xl carbon-weave-bg`}>
                <div className="flex items-center gap-4">
                    <div className={`${status.color}`}>
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="7" y1="17" x2="17" y2="7"></line>
                            <polyline points="7 7 17 7 17 17"></polyline>
                        </svg>
                    </div>
                    <div className="flex flex-col">
                        <span className="text-[10px] font-black tracking-[0.2em] text-slate-500 uppercase">REALE RENTABILITÄT</span>
                        <span className={`text-xl font-black font-mono-numbers tabular-nums leading-none mt-1 ${status.color}`}>
                            {formatNumber(rentabilitaet * 100, 1, '%')}
                        </span>
                    </div>
                </div>
                <div className="flex flex-col items-end">
                    <span className="text-[10px] text-slate-600 font-bold tracking-widest uppercase">STATUS</span>
                    <span className={`text-[11px] lg:text-sm tracking-widest font-black ${status.color}`}>{status.label}</span>
                </div>
            </div>

            {/* 💉 CHIRURGIE: Neuer Veto/Erklärungs-Text Bereich */}
            <div className={`carbon-content px-4 py-3 bg-stone-100 dark:bg-[#050505] border-b ${status.border}`}>
                <p className={`text-[11px] font-sans ${status.color.replace(/led-[a-z]+/, '').trim()}`}>
                    {status.text}
                </p>
            </div>

            <div className="carbon-content p-4 flex items-start gap-3 shadow-inner">
                <div className="text-blue-500 mt-1 shrink-0">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="16" x2="12" y2="12"></line>
                        <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </svg>
                </div>
                <div className="flex flex-col space-y-1">
                    <p className="text-[13px] text-slate-400 italic leading-relaxed">
                        Realer Inhaber-Ertrag von <span className="font-bold font-mono-numbers text-phantom-gold led-gold">{formatValueOnly(inhaberErtrag, 0)} {currency} pro Monat</span> (vor Steuern). Der Wert beinhaltet Deinen Überschuss, Entnahmen und kalkulierte Lohnsteuer.
                    </p>
                    <p className="text-[11px] text-blue-400/80 font-bold italic">
                        Bespreche die finale Steuerlast bitte mit Deinem Steuerberater.
                    </p>
                </div>
            </div>
        </div>
    );
};

const SimpleTooltip: React.FC<{ children: React.ReactNode, text?: string }> = ({ children, text }) => {
    if (!text) return <>{children}</>;
    return (
        <div data-tooltip-id="app-tooltip" data-tooltip-content={text} className="w-full h-full flex items-center justify-center cursor-help">
            {children}
        </div>
    );
};

interface FormulaDisplayProps {
    show: boolean;
    value: number | string;
    formula: string;
    type?: 'currency' | 'percentage' | 'number' | 'text';
    decimalPlaces?: number;
    suffix?: string;
    highlightNegative?: boolean;
    isZielProzent?: boolean;
    zielProzentWert?: number;
    bgColor?: string;
    textColor?: string;
    isLocked?: boolean;
    ruecklagenZielFaktor: number;
    currency: string; 
    className?: string;
}

const FormulaDisplay: React.FC<FormulaDisplayProps> = ({ show, value, formula, type = 'currency', decimalPlaces = 0, suffix = '', highlightNegative = false, isZielProzent = false, zielProzentWert = 0, bgColor, textColor, isLocked = false, ruecklagenZielFaktor, currency, className = '' }) => {
    if (show) {
        return <div className="bg-pe-tile-header dark:bg-black/90 text-pe-accent-text dark:text-white text-xs font-mono-numbers p-1 rounded-md h-8 flex items-center justify-center text-center overflow-hidden whitespace-nowrap text-ellipsis border border-pe-border-strong" title={formula}>{formula}</div>;
    }

    let displayValue;
    const numberValue = Number(value);
      
    if (type === 'text') {
        displayValue = value;
    } else if (isNaN(numberValue)) {
        displayValue = "-";
    } else if (type === 'currency') {
        displayValue = formatValueOnly(numberValue, decimalPlaces); 
    } else if (type === 'percentage') {
        displayValue = formatPercentage(numberValue, decimalPlaces); 
    } else {
        displayValue = formatNumber(numberValue, decimalPlaces, suffix);
    }

    let finalSuffix = suffix;
    if (type === 'currency' && !suffix) finalSuffix = currency;

    let finalTextColor = textColor || 'text-phantom-gold';

    if (isZielProzent) {
        const prozentWert = isZielProzent ? zielProzentWert : numberValue;
        if (prozentWert === 0) {
             finalTextColor = 'text-slate-500';
        } else if (prozentWert < 0) {
            finalTextColor = 'text-red-400 led-red';
        } else if (prozentWert < ruecklagenZielFaktor) {
            finalTextColor = 'text-amber-400 led-amber';
        } else {
            finalTextColor = 'text-emerald-400 led-emerald';
        }
    } else if (highlightNegative) {
        if (numberValue < 0) finalTextColor = 'text-red-400 led-red';
    }

    const finalBgColor = bgColor || 'bg-pe-input';

    return (
        <div className={`w-full min-h-[34px] h-9 px-1.5 relative rounded-md ${finalBgColor} ${className} flex items-center justify-end border border-pe-border-strong`}>
             <span className={`w-full text-right font-bold font-mono-numbers tabular-nums text-sm whitespace-nowrap ${finalTextColor} ${finalSuffix ? 'pr-10' : 'pr-2'}`}>
                {displayValue}
             </span>
             {finalSuffix && type !== 'percentage' && (
                <div className={`absolute right-2 top-1/2 -translate-y-1/2 font-sans text-xs font-bold tracking-widest pointer-events-none select-none text-slate-600`}>
                    {finalSuffix}
                </div>
             )}
        </div>
    );
};

interface InfoCardProps {
    title: string;
    value: number;
    type?: 'currency' | 'number';
    decimalPlaces?: number;
    currency: string;
    customColor?: string;
    tooltip?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({ title, value, type = 'currency', decimalPlaces = 0, currency, customColor, tooltip }) => (
    <div data-tooltip-id="app-tooltip" data-tooltip-content={tooltip} className="cursor-help bg-pe-card dark:bg-[#111] w-full min-h-[100px] py-3 px-2 rounded-xl text-center shadow-xl border border-pe-border dark:border-pe-border-strong hover:border-pe-border-strong dark:hover:border-[#555] transition-colors flex flex-col items-center justify-start">
        <div className="h-[30px] w-full flex items-center justify-center shrink-0 mb-1">
            <h4 className="text-xs font-semibold text-pe-muted uppercase tracking-wider leading-tight px-1">{title}</h4>
        </div>
        <div className="w-full flex justify-center h-full items-center pointer-events-none">
             <EditableField 
                value={value} 
                readOnly={true} 
                transparent={true} 
                type={type} 
                decimalPlaces={decimalPlaces} 
                currency={currency}
                className="justify-center [&>input]:text-2xl [&>input]:font-black [&>input]:font-mono-numbers [&>input]:text-center"
                style={customColor ? { color: customColor } : { color: 'var(--pe-accent-text)' }}
            />
        </div>
    </div>
);

interface HighlightCardProps {
    title: string;
    value: number;
    subtext?: string;
    currency: string;
    tooltip?: string;
}

const HighlightCard: React.FC<HighlightCardProps> = ({ title, value, subtext, currency, tooltip }) => (
    <div data-tooltip-id="app-tooltip" data-tooltip-content={tooltip} className="cursor-help bg-white dark:bg-[#18181a] w-full min-h-[100px] py-3 px-2 rounded-xl text-center border border-phantom-gold/30 shadow-[0_0_15px_rgba(230,194,153,0.1)] h-full flex flex-col items-center justify-start">
        <div className="h-[30px] w-full flex items-center justify-center shrink-0 mb-1">
             <h3 className="text-xs font-semibold text-pe-muted font-sans uppercase tracking-wider leading-tight px-1">{title}</h3>
        </div>
        <div className="w-full flex flex-col items-center h-full justify-center">
             <div className="text-3xl font-black text-phantom-gold led-gold font-mono-numbers tabular-nums tracking-tight">
                {formatCurrencyString(value, currency)}
             </div>
             {subtext && <p className="text-xs font-semibold text-pe-muted uppercase tracking-wider mt-2">{subtext}</p>}
        </div>
    </div>
);

interface UmsatzAmpelProps {
    umsatz: number;
    kostendeckung: number;
    ruecklagenZielValue: number;
    ruecklagenZielFaktor: number;
    istProzent?: number;
}
const UmsatzAmpelMitText: React.FC<UmsatzAmpelProps> = ({ umsatz, kostendeckung, ruecklagenZielValue, ruecklagenZielFaktor, istProzent }) => {
    let icon, text, textColor, tooltipText;
    const zielProzentLabel = formatPercentage(ruecklagenZielFaktor || 0, 0);
    const istProzentWert = Number.isFinite(istProzent)
        ? Number(istProzent)
        : (kostendeckung ? (umsatz - kostendeckung) / kostendeckung : 0);
    const istProzentLabel = formatPercentage(istProzentWert, 1);

    if (!umsatz || umsatz <= 0) {
        icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H4" /></svg>; 
        text = '-';
        textColor = 'text-slate-600';
        tooltipText = "Keine Daten vorhanden.";
    } else if (umsatz < kostendeckung) {
        icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.738 3h4.017c.993 0 1.854-.656-2.148-1.595l2 6A2 2 0 0116.75 14v5a2 2 0 01-2-2h-2.5a2 2 0 01-2-2v-5z" /></svg>;
        text = 'Nicht kostendeckend';
        textColor = 'text-red-400';
        tooltipText = `Kritisch: Der erwirtschaftete Umsatz reicht nicht aus, um die Kosten zu decken. IST ${istProzentLabel}, Ziel ${zielProzentLabel}.`;
    } else if (umsatz < ruecklagenZielValue) {
        icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
        text = 'Kostendeckend';
        textColor = 'text-amber-400';
        tooltipText = `Kostendeckend: Die Kosten sind gedeckt, aber das Rücklagenziel von ${zielProzentLabel} wurde noch nicht erreicht (IST ${istProzentLabel}).`;
    } else {
        icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
        text = 'Ziel erreicht';
        textColor = 'text-emerald-400';
        tooltipText = `Exzellent: Das Rücklagenziel von ${zielProzentLabel} wurde erreicht oder übertroffen (IST ${istProzentLabel}).`;
    }
    return (
        <div data-tooltip-id="app-tooltip" data-tooltip-content={tooltipText} className="flex flex-col items-center justify-center space-y-1 p-1 h-full cursor-help">
            <div className={`flex-shrink-0 ${textColor}`}>{icon}</div>
            <div className={`text-[10px] font-bold text-center leading-tight ${textColor} font-sans`}>{text}</div>
        </div>
    );
};

interface LeistungsFeedbackBoxProps {
    prozent: number;
    gewinn: number;
    ruecklagenZielFaktor: number;
}
const LeistungsFeedbackBox: React.FC<LeistungsFeedbackBoxProps> = ({ prozent, gewinn, ruecklagenZielFaktor }) => {
    const zielProzentLabel = formatPercentage(ruecklagenZielFaktor || 0, 0);
    const istProzentLabel = formatPercentage(prozent || 0, 1);
    let boxClasses, icon, title, text;

    if (gewinn === 0 && prozent === 0) {
        boxClasses = "bg-pe-card border-pe-border-strong";
        icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
        title = <h3 className="font-bold text-pe-muted dark:text-slate-400 uppercase tracking-widest text-xs font-sans">Datenerfassung</h3>;
        text = <p className="text-stone-500 dark:text-slate-500 text-xs font-sans mt-1">Trage deine monatlichen Umsätze ein, um eine Auswertung zu erhalten.</p>;
    } else if (gewinn < 0) {
        boxClasses = "bg-red-100/80 dark:bg-red-950/20 border-red-300 dark:border-red-500/50 animate-pulse";
        icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-red-500 led-red" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
        title = <h3 className="font-bold text-red-950 dark:text-red-400 uppercase tracking-widest text-xs font-sans">SYSTEM-ALARM: KRITISCHE SITUATION!</h3>;
        text = <p className="text-red-900 dark:text-red-300 text-xs font-sans mt-1">Der Verlust ist so hoch, dass der kalkulatorische Unternehmerlohn nicht mehr gedeckt ist. Es besteht **existenzielle Gefahr**. IST-Rücklage <strong className="font-mono-numbers">{istProzentLabel}</strong> (Ziel {zielProzentLabel}).</p>;
    } else if (prozent < 0) {
        boxClasses = "bg-orange-100/80 dark:bg-orange-950/20 border-orange-300 dark:border-orange-500/50";
        icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-orange-500 led-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
        title = <h3 className="font-bold text-orange-950 dark:text-orange-400 uppercase tracking-widest text-xs font-sans">Dringender Handlungsbedarf</h3>;
        text = <p className="text-orange-900 dark:text-orange-300 text-xs font-sans mt-1">Das Unternehmen arbeitet derzeit nicht kostendeckend. IST-Rücklage <strong className="font-mono-numbers">{istProzentLabel}</strong> (Ziel {zielProzentLabel}).</p>;
    } else if (prozent < ruecklagenZielFaktor) {
        boxClasses = "bg-amber-100/80 dark:bg-amber-950/20 border-amber-300 dark:border-amber-500/50";
        icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-yellow-500 led-amber" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
        title = <h3 className="font-bold text-amber-950 dark:text-amber-400 uppercase tracking-widest text-xs font-sans">Ziel offen (Kostendeckend)</h3>;
        text = <p className="text-amber-900 dark:text-amber-200 text-xs font-sans mt-1">Das Unternehmen ist kostendeckend. IST-Rücklage <strong className="font-mono-numbers">{istProzentLabel}</strong>, das Rücklagenziel von <strong className="font-mono-numbers">{zielProzentLabel}</strong> wurde jedoch noch nicht erreicht.</p>;
    } else {
        boxClasses = "bg-emerald-100/80 dark:bg-emerald-950/20 border-emerald-300 dark:border-emerald-500/30 shadow-[0_0_15px_rgba(16,185,129,0.15)]";
        icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-emerald-500 led-emerald" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
        title = <h3 className="font-bold text-emerald-950 dark:text-emerald-400 uppercase tracking-widest text-xs font-sans">Hervorragende Leistung!</h3>;
        text = <p className="text-emerald-900 dark:text-emerald-300 text-xs font-sans mt-1">Glückwunsch! IST-Rücklage <strong className="font-mono-numbers">{istProzentLabel}</strong> — das Rücklagenziel von <strong className="font-mono-numbers">{zielProzentLabel}</strong> wurde übertroffen.</p>;
    }
    return (
        <div className={`carbon-panel p-4 rounded-xl flex items-start space-x-4 h-full border ${boxClasses}`}>
            <div className="carbon-content flex-shrink-0">{icon}</div>
            <div className="carbon-content">{title}{text}</div>
        </div>
    );
};

const getVkFaktorColor = (wertProzent: number): string => {
    // Keine Einträge / 0% = neutral, nicht „negativ rot“
    if (isNaN(wertProzent) || wertProzent <= 0) return 'text-slate-500';
    if (wertProzent >= 15) return 'text-purple-400 led-purple';
    if (wertProzent >= 10) return 'text-emerald-400 led-emerald';
    if (wertProzent >= 6.9) return 'text-lime-400 led-lime';
    if (wertProzent >= 5) return 'text-amber-400 led-amber';
    if (wertProzent >= 3) return 'text-orange-400 led-orange';
    return 'text-red-400 led-red';
};

interface MitarbeiterTabelleProps {
    personalData: EmployeeData[];
    liveCalculatedLeistung: { [employeeId: string]: Partial<MitarbeiterLeistungData> };
    isHJ2Freigegeben: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    founderRows: { id: string, name: string, metrics: any }[];
}

const MitarbeiterTabelle: React.FC<MitarbeiterTabelleProps> = ({ personalData, liveCalculatedLeistung, isHJ2Freigegeben, founderRows }) => {
    const renderLeistungIcon = (status: MitarbeiterStatus | null | undefined) => {
        let tooltipText = ""; let icon = null;
        if (status === 'ok') {
             icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-emerald-500 drop-shadow-[0_0_5px_rgba(16,185,129,0.5)]" viewBox="0 0 20 20" fill="currentColor"><path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" /></svg>; tooltipText = "Leistung im Zielbereich.";
        } else if (status === 'schlecht') {
             icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" viewBox="0 0 20 20" fill="currentColor"><path d="M18 9.5a1.5 1.5 0 11-3 0v-6a1.5 1.5 0 013 0v6zM14 9.667v-5.43a2 2 0 00-1.105-1.79l-.05-.025A4 4 0 0011.055 2H5.64a2 2 0 00-1.962 1.608l-1.2 6A2 2 0 004.44 12H8v4a2 2 0 002 2 1 1 0 001-1v-.667a4 4 0 01.8-2.4l1.4-1.866a4 4 0 00.8-2.4z" /></svg>; tooltipText = "Kritisch: Leistung stark unter Erwartung.";
        } else if (status === 'warnung') {
             icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-500 drop-shadow-[0_0_5px_rgba(245,158,11,0.5)]" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>; tooltipText = "Warnung: Leistung grenzwertig.";
        } else {
             icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" /></svg>; tooltipText = "Keine Daten / Neutral";
        }
        return <SimpleTooltip text={tooltipText}>{icon}</SimpleTooltip>;
    };
      
    const BewertungsBadge: React.FC<{wert: number, typ: 'effizienz' | 'verkaufsfaktor' | 'auslastung'}> = ({ wert, typ }) => {
        if (wert === null || wert === undefined || isNaN(wert) || wert === 0) {
            return (
                <SimpleTooltip text="Keine Daten verfügbar.">
                    <div className="px-3 py-1 rounded-full text-sm font-bold whitespace-nowrap bg-pe-sunken dark:bg-black text-stone-400 dark:text-slate-600 border border-pe-border-strong font-sans inline-block">
                        -
                    </div>
                </SimpleTooltip>
            );
        }

        let level = 6;
        let displayValue = '';
        let tooltip = '';

        if (typ === 'auslastung') {
            const normalizedWert = wert > 5 ? wert / 100 : wert; 
            displayValue = formatPercentage(normalizedWert, 1);
            
            const evalWert = normalizedWert * 100;
            if (evalWert >= 85) level = 1;
            else if (evalWert >= 75) level = 2;
            else if (evalWert >= 70) level = 3;
            else if (evalWert >= 60) level = 4;
            else if (evalWert >= 50) level = 5;
            else level = 6;
            tooltip = `Ø Umsatzauslastung: ${displayValue}. Ziel ist > 75%.`;
        } else if (typ === 'effizienz') {
            displayValue = formatPercentage(wert, 1);
            if (wert >= 1.00) level = 1;
            else if (wert >= 0.95) level = 2;
            else if (wert >= 0.89) level = 3;
            else if (wert >= 0.72) level = 4;
            else if (wert >= 0.63) level = 5;
            else level = 6;
            tooltip = `Ø Effizienz: ${displayValue}.`;
        } else if (typ === 'verkaufsfaktor') {
            displayValue = formatPercentage(wert, 1);
            if (wert >= 0.15) level = 1;
            else if (wert >= 0.10) level = 2;
            else if (wert >= 0.07) level = 3;
            else if (wert >= 0.05) level = 4;
            else if (wert >= 0.03) level = 5;
            else level = 6;
            tooltip = `VK-Faktor: ${displayValue}. Ziel ist > 10%.`;
        }

        let levelName = "";
        let colorClasses = "";

        switch (level) {
            case 1:
                levelName = "Exzellent";
                colorClasses = "text-purple-900 dark:text-purple-400 border-purple-400 dark:border-purple-500/50 bg-purple-100 dark:bg-purple-950/20";
                break;
            case 2:
                levelName = "Sehr Gut";
                colorClasses = "text-emerald-900 dark:text-emerald-400 border-emerald-500 dark:border-emerald-500/50 bg-emerald-100 dark:bg-emerald-950/20";
                break;
            case 3:
                levelName = "Gut";
                colorClasses = "text-lime-900 dark:text-lime-400 border-lime-600 dark:border-lime-500/50 bg-lime-100 dark:bg-lime-950/20";
                break;
            case 4:
                levelName = "Akzeptabel";
                colorClasses = "text-amber-950 dark:text-amber-400 border-amber-500 dark:border-amber-500/50 bg-amber-100 dark:bg-amber-950/20";
                break;
            case 5:
                levelName = "Kritisch";
                colorClasses = "text-orange-900 dark:text-orange-400 border-orange-500 dark:border-orange-500/50 bg-orange-100 dark:bg-orange-950/20";
                break;
            case 6:
            default:
                levelName = "Defizitär";
                colorClasses = "text-red-900 dark:text-red-400 border-red-500 dark:border-red-500/50 bg-red-100 dark:bg-red-950/20";
                break;
        }

        return (
            <SimpleTooltip text={tooltip}>
                <div className={`px-3 py-1 rounded-full text-[10px] uppercase tracking-widest font-bold whitespace-nowrap border ${colorClasses} font-sans inline-flex items-center justify-center`}>
                    {levelName} <span className="ml-2 font-mono-numbers text-sm">{displayValue}</span>
                </div>
            </SimpleTooltip>
        );
    };

    const produktiveMitarbeiter = personalData || [];

    return (
        <div className="carbon-panel border border-pe-border-strong h-full w-full bg-pe-card dark:bg-[#030303]">
            <table className="text-sm w-full carbon-content min-w-max">
                <thead className="bg-pe-elevated text-pe-muted border-b-2 border-pe-border-strong">
                    <tr>
                        <th className="p-3 text-left border-r border-pe-border dark:border-[#222] font-sans text-xs font-semibold uppercase tracking-wider min-w-[200px]">Mitarbeiter</th>
                        <th className="p-3 text-center border-r border-pe-border dark:border-[#222] font-sans text-xs font-semibold uppercase tracking-wider min-w-[140px]">Ø Effizienz<br/><span className="text-[9px] font-bold text-slate-600">(Ref. 100%)</span></th>
                        <th className="p-3 text-center border-r border-pe-border dark:border-[#222] font-sans text-xs font-semibold uppercase tracking-wider min-w-[140px]">VK-Faktor<br/><span className="text-[9px] font-bold text-slate-600">(Ziel 10%)</span></th>
                        <th className="p-3 text-center border-r border-pe-border dark:border-[#222] font-sans text-xs font-semibold uppercase tracking-wider">Krank</th>
                        <th className="p-3 text-center border-r border-pe-border dark:border-[#222] font-sans text-xs font-semibold uppercase tracking-wider">1. Hj.</th>
                        <th className="p-3 text-center border-r border-pe-border dark:border-[#222] font-sans text-xs font-semibold uppercase tracking-wider">2. Hj.</th>
                        <th className="p-3 text-center font-sans text-xs font-semibold uppercase tracking-wider min-w-[140px]">Ø Auslastung<br/><span className="text-[9px] font-bold text-slate-600">(Umsatz)</span></th>
                    </tr>
                </thead>
                <tbody className="font-bold bg-transparent">
                    {/* MITARBEITER */}
                    {produktiveMitarbeiter.map((ma: EmployeeData) => {
                        if (!ma || !ma.id) return null;
                        
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const leistung = liveCalculatedLeistung?.[ma.id] ?? {} as any; 
                        
                        const realAuslastung = leistung.calculatedAvgUmsatzauslastung ?? 0;
                        const realVkFaktor = leistung.calculatedAvgVkFaktor ?? 0;
                        
                        return (
                            <tr key={ma.id} className="border-b border-pe-border-strong hover:bg-pe-hover dark:hover:bg-[#1a1a1a] transition-colors">
                                <td className="p-3 text-left text-pe-text font-sans text-sm border-r border-pe-border dark:border-[#222]">{ma.name}</td>
                                <td className="p-3 text-center border-r border-pe-border dark:border-[#222]"><BewertungsBadge wert={leistung?.calculatedAvgEfficiency ?? 0} typ="effizienz" /></td>
                                <td className="p-3 text-center border-r border-pe-border dark:border-[#222]"><BewertungsBadge wert={realVkFaktor} typ="verkaufsfaktor" /></td>
                                <td className="p-3 text-center text-orange-700 dark:text-orange-400 font-mono-numbers text-sm border-r border-pe-border dark:border-[#222]"><SimpleTooltip text="Summe der Krankheitstage im ausgewählten Zeitraum.">{formatNumber(leistung?.calculatedSumKrankTage ?? 0, 0, ' T.')}</SimpleTooltip></td>
                                <td className="p-3 border-r border-pe-border dark:border-[#222]"><div className="flex justify-center">{renderLeistungIcon(leistung?.calculatedStatusHJ1)}</div></td>
                                <td className="p-3 border-r border-pe-border dark:border-[#222]">{isHJ2Freigegeben && (<div className="flex justify-center">{renderLeistungIcon(leistung?.calculatedStatusHJ2)}</div>)}</td>
                                <td className="p-3 text-center"><BewertungsBadge wert={realAuslastung} typ="auslastung" /></td>
                            </tr>
                        )
                    })}

                    {/* DYNAMISCHE FOUNDER-ROWS (Einzel oder Personengesellschaft) */}
                    {founderRows.map((founder) => (
                        <tr key={founder.id} className="border-t-2 border-pe-border-strong dark:border-[#444] bg-pe-elevated hover:bg-pe-card transition-colors">
                            <td className="p-4 text-left text-phantom-gold font-sans font-black text-xs uppercase tracking-widest border-r border-pe-border-strong">{founder.name}</td>
                            <td className="p-4 text-center border-r border-pe-border-strong"><BewertungsBadge wert={founder.metrics?.efficiency || 0} typ="effizienz" /></td>
                            <td className="p-4 text-center border-r border-pe-border-strong"><BewertungsBadge wert={founder.metrics?.vkFaktor || 0} typ="verkaufsfaktor" /></td>
                            <td className="p-4 text-center text-orange-700 dark:text-orange-400 font-mono-numbers text-sm border-r border-pe-border-strong"><SimpleTooltip text="Krankheitstage (aus Unternehmer-Planung)">{formatNumber(founder.metrics?.sumKrankTage || 0, 0, ' T.')}</SimpleTooltip></td>
                            <td className="p-4 text-center text-sm text-slate-600 font-sans border-r border-pe-border-strong">-</td>
                            <td className="p-4 text-center text-sm text-slate-600 font-sans border-r border-pe-border-strong">-</td>
                            <td className="p-4 text-center text-sm text-slate-500 font-sans"><BewertungsBadge wert={founder.metrics?.umsatzauslastung || 0} typ="auslastung" /></td>
                        </tr>
                    ))}
                 </tbody>
            </table>
        </div>
    );
};

interface UrlaubsverlustRechnerProps {
  data: UrlaubsverlustData[]; 
  onUpdate: (index: number, field: 'urlaub' | 'krankheit', value: number) => void;
  umsatzProTag: number;
  auslastungsFaktor: number;
  showFormulas: boolean;
  ruecklagenZielFaktor: number;
  currencyCode: string;
}

const UrlaubsverlustRechner: React.FC<UrlaubsverlustRechnerProps> = ({ data, onUpdate, umsatzProTag, auslastungsFaktor, showFormulas, ruecklagenZielFaktor, currencyCode }) => {
    const [isOpen, setIsOpen] = useState(false);
    
    const safeData = data || [];
    
    return (
        <div className="carbon-panel border border-pe-border-strong overflow-hidden transition-all duration-300 h-fit w-full bg-pe-card dark:bg-[#030303]">
            <div onClick={() => setIsOpen(!isOpen)} className="carbon-content carbon-weave-bg p-4 cursor-pointer hover:opacity-95 transition-colors flex items-center justify-between border-b border-pe-border-strong group select-none">
                <div className="flex items-center gap-3">
                      <div className={`p-1.5 rounded-full border border-pe-border-strong dark:border-slate-700 ${isOpen ? 'bg-pe-tile-header dark:bg-slate-800 text-blue-700 dark:text-blue-400' : 'bg-blue-600 text-white'} transition-colors`}><svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 transform transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg></div>
                      <h3 className="text-[12px] font-black uppercase tracking-widest text-pe-text font-sans">Urlaubs- & Krankheitstageverlust-Rechner</h3>
                </div>
                <span className="text-[10px] uppercase font-bold tracking-widest text-blue-500 group-hover:text-blue-400 font-sans mr-2">{isOpen ? 'Einklappen' : 'Klicken zum Einblenden'}</span>
            </div>
            {isOpen && (
                <div className="carbon-content p-2 animate-in slide-in-from-top-2 duration-300">
                    <table className="text-sm w-full border-collapse min-w-max">
                        <thead className="text-slate-400 bg-pe-elevated">
                            <tr><th className="p-2 text-left font-bold text-[10px] uppercase tracking-widest font-sans">Monat</th><th className="p-2 text-center font-bold text-[10px] uppercase tracking-widest font-sans">gepl. Urlaub</th><th className="p-2 text-center font-bold text-[10px] uppercase tracking-widest font-sans">Krankheit</th><th className="p-2 text-center font-bold text-[10px] uppercase tracking-widest font-sans">Gesamt</th><th className="p-2 text-center font-bold text-[10px] uppercase tracking-widest font-sans">progn. Umsatzverlust</th></tr>
                        </thead>
                        <tbody>
                            {safeData.map((m, index) => {
                                const urlaubTage = m?.urlaub || 0;
                                const krankheitTage = m?.krankheit || 0;
                                const gesamtTage = urlaubTage + krankheitTage;
                                const verlust = umsatzProTag * gesamtTage * ((auslastungsFaktor || 75) / 100);
                                const formel = `${formatCurrencyString(umsatzProTag, currencyCode)} * ${gesamtTage} Tage * ${auslastungsFaktor || 75}%`;
                                return (
                                    <tr key={m?.monat || index} className="border-b border-pe-border dark:border-[#222] last:border-b-0 hover:bg-pe-hover dark:hover:bg-black/40">
                                            <td className="p-1 pl-3 font-bold text-[10px] uppercase tracking-widest text-left text-slate-300 font-sans min-w-[80px]">{m?.monat || `Monat ${index + 1}`}</td>
                                            <td className="p-1 w-24 h-10" data-tooltip-id="app-tooltip" data-tooltip-content="Vorausschau: Trage hier den geplanten Urlaub des Teams ein, um den Risiko-Verlust zu berechnen."><EditableField variant="days" value={urlaubTage} onChange={(v) => onUpdate(index, 'urlaub', v)} suffix="Tage" currency={currencyCode} className="bg-pe-input border-stone-300 dark:border-white/10 text-stone-900 dark:text-white font-mono-numbers" /></td>
                                            <td className="p-1 w-24 h-10" data-tooltip-id="app-tooltip" data-tooltip-content="Vorausschau: Trage hier prognostizierte oder tatsächliche Krankheitstage ein."><EditableField variant="days" value={krankheitTage} onChange={(v) => onUpdate(index, 'krankheit', v)} suffix="Tage" currency={currencyCode} className="bg-pe-input border-stone-300 dark:border-white/10 text-stone-900 dark:text-white font-mono-numbers" /></td>
                                            <td className="p-1 text-center font-black text-orange-400 w-24 font-mono-numbers tabular-nums">{formatNumber(gesamtTage, 0, ' Tage')}</td>
                                            <td className="p-1 w-36" data-tooltip-id="app-tooltip" data-tooltip-content="Prognostizierter Umsatzverlust (Worst Case)"><FormulaDisplay show={showFormulas} value={verlust} formula={formel} type="currency" ruecklagenZielFaktor={ruecklagenZielFaktor} currency={currencyCode} textColor="text-red-400" /></td>
                                    </tr>
                                );
                            })}
                            </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Calculations = any;

interface PlanzieleSektionProps {
 calculations: Calculations;
 planStunden: number;
 setPlanStunden: (value: number) => void;
 ruecklagenZielFaktor: number;
 umsatzauslastung: number;
 monatsStunden: number;
 arbeitstageProMonat: number;
 auslastungsFaktor: number;
 currencyCode: string;
 mwstFaktor: number;
 targetMindestumsatz: number; 
 hatVorjahresdaten: boolean;
 setHatVorjahresdaten: (val: boolean) => void;
 isSolo: boolean;
 soloUrlaub: number;
 onUpdateSoloUrlaub: (val: number) => void;
 onStartEditVJ: () => void;
 isEditModeVJ: boolean;
}

const PlanzieleSektion: React.FC<PlanzieleSektionProps> = ({ 
    planStunden, setPlanStunden, ruecklagenZielFaktor, monatsStunden, arbeitstageProMonat, auslastungsFaktor, currencyCode, mwstFaktor, targetMindestumsatz, hatVorjahresdaten, setHatVorjahresdaten, isSolo, soloUrlaub, onUpdateSoloUrlaub, onStartEditVJ, isEditModeVJ
}) => {
    const MONATSSTUNDEN = monatsStunden || 1;
    const ARBEITSTAGE_PRO_MONAT = arbeitstageProMonat || 1;
    const avgMindestNettoKostendeckung = targetMindestumsatz || 0;
    const avgMindestNettoRuecklagen = avgMindestNettoKostendeckung * (1 + (ruecklagenZielFaktor || 0));
        
    const safeAuslastungsFaktor = auslastungsFaktor || 75;

    const kostendeckung = {
        monatNetto: avgMindestNettoKostendeckung,
        tagNetto: safeDiv(avgMindestNettoKostendeckung, ARBEITSTAGE_PRO_MONAT),
        stdNetto: safeDiv(avgMindestNettoKostendeckung, MONATSSTUNDEN),
        stundenGesamtNetto: safeDiv(avgMindestNettoKostendeckung, MONATSSTUNDEN) * (planStunden || 0),
        monatBrutto: avgMindestNettoKostendeckung * (mwstFaktor || 1),
        tagBrutto: safeDiv(avgMindestNettoKostendeckung, ARBEITSTAGE_PRO_MONAT) * (mwstFaktor || 1),
        stdBrutto: safeDiv(avgMindestNettoKostendeckung, MONATSSTUNDEN) * (mwstFaktor || 1),
        stundenGesamtBrutto: safeDiv(avgMindestNettoKostendeckung, MONATSSTUNDEN) * (planStunden || 0) * (mwstFaktor || 1),
        mindestUmsatzBrutto75: safeDiv(safeDiv(avgMindestNettoKostendeckung, MONATSSTUNDEN) * (mwstFaktor || 1), safeAuslastungsFaktor / 100),
    };

    const ruecklagen = {
        monatNetto: avgMindestNettoRuecklagen,
        tagNetto: safeDiv(avgMindestNettoRuecklagen, ARBEITSTAGE_PRO_MONAT),
        stdNetto: safeDiv(avgMindestNettoRuecklagen, MONATSSTUNDEN),
        stundenGesamtNetto: safeDiv(avgMindestNettoRuecklagen, MONATSSTUNDEN) * (planStunden || 0),
        monatBrutto: avgMindestNettoRuecklagen * (mwstFaktor || 1),
        tagBrutto: safeDiv(avgMindestNettoRuecklagen, ARBEITSTAGE_PRO_MONAT) * (mwstFaktor || 1),
        stdBrutto: safeDiv(avgMindestNettoRuecklagen, MONATSSTUNDEN) * (mwstFaktor || 1),
        stundenGesamtBrutto: safeDiv(avgMindestNettoRuecklagen, MONATSSTUNDEN) * (planStunden || 0) * (mwstFaktor || 1),
        mindestUmsatzBrutto75: safeDiv(safeDiv(avgMindestNettoRuecklagen, MONATSSTUNDEN) * (mwstFaktor || 1), safeAuslastungsFaktor / 100),
    };

    const soloBoostFactor = useMemo(() => {
        if (!isSolo) return 1;
        const sollTageJahr = ARBEITSTAGE_PRO_MONAT * 12;
        const verfügbareTage = sollTageJahr - (soloUrlaub || 0) - PAUSCHAL_FEIERTAGE;
        return verfügbareTage > 0 ? sollTageJahr / verfügbareTage : 1;
    }, [isSolo, soloUrlaub, ARBEITSTAGE_PRO_MONAT]);

    const soloColor = "#CC8A84";
    const hasUrlaub = (soloUrlaub || 0) > 0;

    return (
        <div className="mb-8 p-6 carbon-panel border border-pe-border-strong max-w-6xl w-full bg-pe-card dark:bg-[#030303]">
            <div className="carbon-content mb-6">
                <h3 className="text-[12px] font-black tracking-widest text-pe-muted dark:text-slate-400 uppercase mb-4 border-b border-pe-border-strong pb-2 px-4 py-2 carbon-weave-bg rounded-lg font-sans">Umsatzziele Kostendeckung (Nur Kosten decken)</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-6 mb-6">
                    <InfoCard tooltip="Der benötigte Netto-Umsatz pro gearbeiteter Stunde, um die Kostendeckung zu erreichen." title="Mindestumsatz p. Std netto" value={kostendeckung.stdNetto} currency={currencyCode} />
                    <InfoCard tooltip="Der benötigte Netto-Umsatz pro regulärem Arbeitstag." title="Ø Mindestumsatz p. Tag netto" value={kostendeckung.tagNetto} currency={currencyCode} />
                    <InfoCard tooltip="Der benötigte Netto-Umsatz für die unten definierte Tages-Stunden-Planung." title="Mindestumsatz p. Stunden netto" value={kostendeckung.stundenGesamtNetto} currency={currencyCode} />
                    <InfoCard tooltip="Der absolut notwendige Netto-Umsatz auf den gesamten Monat gesehen." title="Mindestumsatz p. Monat netto" value={kostendeckung.monatNetto} currency={currencyCode} />
                    
                    <InfoCard tooltip="Der benötigte Brutto-Umsatz pro gearbeiteter Stunde." title="Mindestumsatz p. Std brutto" value={kostendeckung.stdBrutto} currency={currencyCode} />
                    <InfoCard tooltip="Der benötigte Brutto-Umsatz pro Arbeitstag." title="Ø Mindestumsatz p. Tag brutto" value={kostendeckung.tagBrutto} currency={currencyCode} />
                    <InfoCard tooltip="Der benötigte Brutto-Umsatz für die unten definierte Tages-Stunden-Planung." title="Mindestumsatz p. Stunden brutto" value={kostendeckung.stundenGesamtBrutto} currency={currencyCode} />
                    <InfoCard tooltip="Der absolut notwendige Brutto-Umsatz auf den gesamten Monat gesehen." title="Mindestumsatz p. Monat brutto" value={kostendeckung.monatBrutto} currency={currencyCode} />

                    {isSolo && hasUrlaub && (
                        <>
                            <InfoCard tooltip="Kalkulierter Stundenumsatz inkl. Risiko-Ausgleich für deinen Jahresurlaub." title="Mindestumsatz p. Std brutto inkl. Urlaub" value={kostendeckung.stdBrutto * soloBoostFactor} currency={currencyCode} customColor={soloColor} />
                            <InfoCard tooltip="Kalkulierter Tagesumsatz inkl. Risiko-Ausgleich für deinen Jahresurlaub." title="Ø Mindestumsatz p. Tag brutto inkl. Urlaub" value={kostendeckung.tagBrutto * soloBoostFactor} currency={currencyCode} customColor={soloColor} />
                            <InfoCard tooltip="Kalkulierter Planumsatz für die definierte Stundenzahl inkl. Urlaubsausgleich." title="Mindestumsatz p. Stunden brutto inkl. Urlaub" value={kostendeckung.stundenGesamtBrutto * soloBoostFactor} currency={currencyCode} customColor={soloColor} />
                            <InfoCard tooltip="Kalkulierter Monatsumsatz inkl. Risiko-Ausgleich für deinen Jahresurlaub." title="Mindestumsatz p. Monat brutto inkl. Urlaub" value={kostendeckung.monatBrutto * soloBoostFactor} currency={currencyCode} customColor={soloColor} />
                        </>
                    )}
                </div>
                 <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-6 items-stretch">
                        <div className="col-span-1">
                            <HighlightCard tooltip={`Dieser Brutto-Stundenumsatz wird benötigt, wenn der Salon im Schnitt nur zu ${safeAuslastungsFaktor}% ausgelastet ist.`} title={`Mindestumsatz pro Std. (Brutto) bei ${safeAuslastungsFaktor}% Auslastung`} value={kostendeckung.mindestUmsatzBrutto75} currency={currencyCode} />
                        </div>
                        <div className="col-span-1 md:col-span-2 bg-pe-card w-full min-h-[100px] py-3 px-4 rounded-xl text-sm text-pe-muted dark:text-slate-400 flex items-center border border-pe-border-strong shadow-xl font-sans">
                            <p>Info: Um die Umsatzwerte am Ende des Monats erreichen zu können, brauchen wir Ø <strong className="text-orange-400 font-bold">mehr Umsatz!</strong> Denn wir gehen von einer Gesamtauslastung von <span className="font-mono-numbers">{safeAuslastungsFaktor}%</span> aus.</p>
                        </div>
                        <div className="col-span-1">
                            <div className="bg-pe-card w-full min-h-[100px] py-3 px-2 rounded-xl text-center shadow-xl border border-pe-border-strong hover:border-phantom-gold/30 transition-colors flex flex-col items-center justify-start cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Gib hier die Stundenanzahl ein, für die das Tagesziel in den Infocards berechnet werden soll (z.B. 8 Std).">
                                 <div className="h-[30px] w-full flex items-center justify-center shrink-0 mb-1">
                                     <label className="text-[10px] font-bold text-slate-500 text-center font-sans uppercase tracking-widest leading-tight px-1">Stunden für Tages-Planung</label>
                                 </div>
                                 <div className="w-full flex justify-center h-full items-center pointer-events-auto">
                                     <EditableField 
                                          variant="hours" 
                                          value={planStunden || 0} 
                                          onChange={setPlanStunden} 
                                          type="number" 
                                          suffix="Std." 
                                          currency={currencyCode} 
                                          className="text-2xl text-stone-900 dark:text-white font-mono-numbers font-black justify-center bg-pe-input border border-stone-300 dark:border-white/10 rounded h-12 w-36" 
                                          transparent={false} 
                                      />
                                 </div>
                            </div>
                        </div>
                 </div>
            </div>

            {isSolo && (
                <div className="carbon-content flex justify-center items-center py-4">
                    <SimpleTooltip text="Dein Jahresurlaub in Tagen. Bildet die Basis für die Umsatzumlegung in den rosa Infocards.">
                        <div className={`p-4 rounded-xl shadow-xl flex flex-col items-center w-64 transition-all ${!hasUrlaub ? 'bg-red-100/80 dark:bg-red-950/20 border border-red-500 animate-pulse' : 'bg-pe-card border border-pe-border-strong'}`}>
                            <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest mb-3">geplanter Jahresurlaub</label>
                            <EditableField variant="days" value={soloUrlaub || 0} onChange={onUpdateSoloUrlaub} type="number" suffix="Tage" currency={currencyCode} className="text-2xl font-black font-mono-numbers text-pe-text justify-center bg-pe-card border border-pe-border-strong dark:border-[#444] rounded-lg h-12 w-32" transparent={false} />
                            {!hasUrlaub && <span className="text-[10px] text-red-500 font-black mt-2">WERT FEHLT!</span>}
                        </div>
                    </SimpleTooltip>
                </div>
            )}

            <div className="carbon-content mb-6 mt-8 w-full max-w-6xl">
                 <h3 className="text-[12px] font-black tracking-widest text-phantom-gold uppercase mb-4 border-b border-pe-border-strong pb-2 px-4 py-2 carbon-weave-bg rounded-lg font-sans">Umsatzziele für Rücklagen + {formatPercentage(ruecklagenZielFaktor || 0, 0)} (Empfohlen)</h3>
                 <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-6 mb-6">
                    <InfoCard tooltip="Der empfohlene Netto-Umsatz pro gearbeiteter Stunde für dein Rücklagenziel." title="Mindestumsatz p. Std netto" value={ruecklagen.stdNetto} currency={currencyCode} />
                    <InfoCard tooltip="Der empfohlene Netto-Umsatz pro Arbeitstag für dein Rücklagenziel." title="Ø Mindestumsatz p. Tag netto" value={ruecklagen.tagNetto} currency={currencyCode} />
                    <InfoCard tooltip="Der empfohlene Netto-Umsatz für die definierte Stunden-Planung." title="Mindestumsatz p. Stunden netto" value={ruecklagen.stundenGesamtNetto} currency={currencyCode} />
                    <InfoCard tooltip="Das empfohlene monatliche Netto-Ziel." title="Mindestumsatz p. Monat netto" value={ruecklagen.monatNetto} currency={currencyCode} />
                    
                    <InfoCard tooltip="Der empfohlene Brutto-Umsatz pro gearbeiteter Stunde." title="Mindestumsatz p. Std brutto" value={ruecklagen.stdBrutto} currency={currencyCode} />
                    <InfoCard tooltip="Der empfohlene Brutto-Umsatz pro Arbeitstag." title="Ø Mindestumsatz p. Tag brutto" value={ruecklagen.tagBrutto} currency={currencyCode} />
                    <InfoCard tooltip="Der empfohlene Brutto-Umsatz für die definierte Stunden-Planung." title="Mindestumsatz p. Stunden brutto" value={ruecklagen.stundenGesamtBrutto} currency={currencyCode} />
                    <InfoCard tooltip="Das empfohlene monatliche Brutto-Ziel." title="Mindestumsatz p. Monat brutto" value={ruecklagen.monatBrutto} currency={currencyCode} />

                    {isSolo && hasUrlaub && (
                        <>
                            <InfoCard tooltip="Kalkulierter Stundenumsatz (Ziel) inkl. Urlaubsausgleich." title="Mindestumsatz p. Std brutto inkl. Urlaub" value={ruecklagen.stdBrutto * soloBoostFactor} currency={currencyCode} customColor={soloColor} />
                            <InfoCard tooltip="Kalkulierter Tagesumsatz (Ziel) inkl. Urlaubsausgleich." title="Ø Mindestumsatz p. Tag brutto inkl. Urlaub" value={ruecklagen.tagBrutto * soloBoostFactor} currency={currencyCode} customColor={soloColor} />
                            <InfoCard tooltip="Kalkulierter Planumsatz (Ziel) für die definierte Stundenzahl inkl. Urlaubsausgleich." title="Mindestumsatz p. Stunden brutto inkl. Urlaub" value={ruecklagen.stundenGesamtBrutto * soloBoostFactor} currency={currencyCode} customColor={soloColor} />
                            <InfoCard tooltip="Kalkulierter Monatsumsatz (Ziel) inkl. Urlaubsausgleich." title="Mindestumsatz p. Monat brutto inkl. Urlaub" value={ruecklagen.monatBrutto * soloBoostFactor} currency={currencyCode} customColor={soloColor} />
                        </>
                    )}
                </div>
                 <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-6 items-stretch">
                        <div className="col-span-1">
                            <HighlightCard tooltip={`Benötigter Brutto-Umsatz pro Stunde bei ${safeAuslastungsFaktor}% Auslastung, um inkl. Rücklagen sicher zu sein.`} title={`Mindestumsatz pro Std. (Brutto) bei ${safeAuslastungsFaktor}% Auslastung`} value={ruecklagen.mindestUmsatzBrutto75} currency={currencyCode} />
                        </div>
                        <div className="col-span-1 md:col-span-1 bg-pe-card w-full min-h-[100px] py-3 px-4 rounded-xl text-sm text-pe-muted dark:text-slate-400 flex items-center border border-pe-border-strong shadow-xl font-sans">
                            <p>Info: Um die Umsatzwerte am Ende des Monats erreichen zu können, brauchen wir Ø <strong className="text-orange-400 font-bold">mehr Umsatz!</strong> Denn wir gehen von einer Gesamtauslastung von <span className="font-mono-numbers">{safeAuslastungsFaktor}%</span> aus.</p>
                        </div>
                        
                        <div className="col-span-1 md:col-span-2 flex flex-wrap items-center justify-end gap-4 h-full w-full">
                            <button 
                                onClick={onStartEditVJ}
                                className={`flex items-center gap-2 px-4 py-3 rounded-lg font-bold text-xs uppercase tracking-widest transition-all border w-full sm:w-auto justify-center ${isEditModeVJ ? 'bg-orange-600 border-orange-400 text-white shadow-[0_0_15px_rgba(234,88,12,0.4)]' : 'bg-pe-elevated border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-slate-400 hover:bg-pe-card hover:text-pe-text'}`}
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                </svg>
                                {isEditModeVJ ? 'Edit-Modus Sperren' : 'Vorjahreswerte editieren'}
                            </button>

                            <div className="flex items-center justify-center gap-2 p-2 rounded-lg bg-transparent w-full sm:w-auto">
                                <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest cursor-pointer select-none font-sans mr-2" htmlFor="vorjahrToggleBottom">Vorjahreswerte anzeigen</label>
                                <input 
                                    id="vorjahrToggleBottom" 
                                    type="checkbox" 
                                    checked={hatVorjahresdaten || false} 
                                    onChange={(e) => setHatVorjahresdaten(e.target.checked)} 
                                    className="form-checkbox h-5 w-5 text-phantom-gold bg-pe-input dark:bg-black border-pe-border-strong dark:border-[#444] rounded focus:ring-phantom-gold/50 cursor-pointer" 
                                />
                            </div>
                        </div>
                 </div>
            </div>
        </div>
    );
};

interface MonatsTabelleProps {
    data: GesamtleistungMonatData[];
    updateMonth: (index: number, field: keyof GesamtleistungMonatData, value: any) => void;
    calculations: Calculations;
    showFormulas: boolean;
    onToggleLock: (index: number) => void;
    hatVorjahresdaten: boolean;
    setHatVorjahresdaten: (val: boolean) => void; 
    privatentnahme: number;
    ruecklagenZielFaktor: number;
    monatsStunden: number;
    auslastungsFaktor: number;
    currencyCode: string;
    mwstFaktor: number;
    teamStats: {urlaub: number, krank: number}[];
    vorjahresDaten: any[];
    updateVorjahr: (index: number, field: string, value: number) => void;
    isEditModeVJ: boolean;
    onPasteVJ: (index: number, field: string, e: React.ClipboardEvent) => void;
    /** Mandant: HJ1 (Index 0–5) gesperrt */
    isHj1InputLocked?: boolean;
}

const MonatsTabelle: React.FC<MonatsTabelleProps> = ({ 
    data, updateMonth, calculations, showFormulas, onToggleLock, hatVorjahresdaten, privatentnahme, ruecklagenZielFaktor, monatsStunden, auslastungsFaktor, currencyCode, mwstFaktor, teamStats, vorjahresDaten, updateVorjahr, isEditModeVJ, onPasteVJ, isHj1InputLocked = false
}) => {
    
    // Feste Pixelbreiten (LeistungPage-Muster, etwas großzügiger wegen mehr Spalten)
    const W = { monat: 92, team: 96, curr: 124, vk: 88, status: 136, std: 140, pct: 88, ae: 124, chk: 72, sep: 16, fest: 96 } as const;
    const tdPad = 'px-2 py-1.5';
    const tableWidthPx = W.monat + W.team + W.curr * 9 + W.vk + W.status + W.std + W.pct + W.chk * 2 + W.sep + W.fest + (hatVorjahresdaten ? W.curr * 2 + W.pct : 0);
    const safeMonatsStunden = monatsStunden || 1;
    const safeMwst = mwstFaktor || 1;
    const safeRuecklagenZiel = ruecklagenZielFaktor || 0;
    
    const sollStundenUmsatzBrutto = safeDiv((calculations?.gesamtjahr?.average?.mindestNetto || 0) * (1 + safeRuecklagenZiel), safeMonatsStunden) * safeMwst;

    const safeData = monthNames.map((n, i) => data?.[i] || { monat: n, bedienumsatzBrutto: 0, vkUmsatzBrutto: 0, aussergewoehnlich: 0, kostenErhoeht: false, abgeschlossen: false });

    const renderRow = (m: GesamtleistungMonatData, i: number) => {
        const halbjahrKey = (i < 6 ? 'halbjahr1' : 'halbjahr2') as 'halbjahr1' | 'halbjahr2';
        const indexInHalbjahr = i % 6;
        const calc = calculations?.[halbjahrKey]?.monatsDetails?.[indexInHalbjahr] || {
            gesamtBrutto: 0, vkFaktor: 0, stdUmsatz: 0, gesamtNetto: 0, mindestNetto: 0, ruecklagenDelta: 0, activePrivatentnahme: privatentnahme || 0, gewinn: 0, prozent: 0, activeMwstFaktor: safeMwst, activeRuecklagenZielFaktor: safeRuecklagenZiel
        };
        const isLocked = m.abgeschlossen;
        const rowHj1Locked = isHj1InputLocked && i < 6;
        const inputsLocked = isLocked || rowHj1Locked;
        const currentTeamStats = teamStats?.[i] || { urlaub: 0, krank: 0 };
        const vorjahr = vorjahresDaten?.[i] || { vorjahrWert1: 0, vorjahrWert2: 0, vorjahrProzent: 0 };

        const vkVal = calc.vkFaktor || 0;
        let vkTextColor = 'text-slate-500'; 
        if (vkVal > 0) {
            if (vkVal >= 15) vkTextColor = 'text-purple-400 led-purple drop-shadow-[0_0_8px_rgba(168,85,247,0.5)]';
            else if (vkVal >= 10) vkTextColor = 'text-emerald-400 led-emerald drop-shadow-[0_0_8px_rgba(16,185,129,0.5)]';
            else if (vkVal >= 7) vkTextColor = 'text-lime-400 led-lime drop-shadow-[0_0_8px_rgba(163,230,53,0.5)]';
            else if (vkVal >= 5) vkTextColor = 'text-amber-400 led-amber drop-shadow-[0_0_8px_rgba(251,191,36,0.5)]';
            else vkTextColor = 'text-red-400 led-red drop-shadow-[0_0_8px_rgba(239,68,68,0.5)]';
        }

        return (
             <React.Fragment key={i}>
                 {i === 0 && (
                    <tr className="bg-pe-card border-b border-t border-pe-border-strong">
                        <td colSpan={hatVorjahresdaten ? 21 : 18} className="py-2 px-3 text-left font-bold text-phantom-gold font-sans text-[11px] uppercase tracking-widest">
                            1. Halbjahr{rowHj1Locked ? ' — gesperrt' : ''}
                        </td>
                    </tr>
                 )}
                 {i === 6 && (<tr className="bg-pe-card border-b border-t border-pe-border-strong"><td colSpan={hatVorjahresdaten ? 21 : 18} className="py-2 px-3 text-left font-bold text-phantom-gold font-sans text-[11px] uppercase tracking-widest">2. Halbjahr</td></tr>)}
                 <tr className={`border-b border-pe-border-strong ${inputsLocked ? 'bg-pe-elevated' : 'hover:bg-pe-hover dark:hover:bg-[#1a1a1a]'} transition-colors`}>
                     <td className={`${tdPad} sticky left-0 z-10 font-sans text-[11px] uppercase tracking-widest ${inputsLocked ? 'bg-stone-100 dark:bg-[#050505]' : 'bg-pe-elevated'}`}>{m.monat}</td>
                     <td className={`${tdPad} text-slate-500 text-xs text-center font-mono-numbers tabular-nums cursor-help`} data-tooltip-id="app-tooltip" data-tooltip-content="Summe Urlaubstage (Mitarbeiter + Chef) in diesem Monat.">{formatNumber(currentTeamStats.urlaub, 1)} T.</td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Eingabe: Der insgesamt erwirtschaftete Bedienumsatz im Salon in diesem Monat."><EditableField className="bg-pe-input border-stone-300 dark:border-white/10 text-stone-900 dark:text-white font-mono-numbers text-sm min-h-[34px] h-9" variant="revenue" type="currency" currency={currencyCode} value={m.bedienumsatzBrutto || 0} onChange={(v) => updateMonth(i, 'bedienumsatzBrutto', v)} readOnly={inputsLocked} /></td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Eingabe: Der insgesamt erwirtschaftete Verkaufsumsatz im Salon in diesem Monat."><EditableField className="bg-pe-input border-stone-300 dark:border-white/10 text-stone-900 dark:text-white font-mono-numbers text-sm min-h-[34px] h-9" variant="revenue" type="currency" currency={currencyCode} value={m.vkUmsatzBrutto || 0} onChange={(v) => updateMonth(i, 'vkUmsatzBrutto', v)} readOnly={inputsLocked} /></td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Errechnet: Summe aus Bedienung und Verkauf."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} value={calc.gesamtBrutto || 0} formula="Bedien + VK" /></td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Verhältnis von Verkaufs- zu Bedienumsatz. Purple: >=15%, Emerald: >=10%, Lime: >=7%, Amber: >=5%, Red: <5%.">
                        <FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} value={(vkVal || 0) / 100} type="percentage" decimalPlaces={1} formula="VK / Bedien" textColor={vkTextColor} bgColor="bg-pe-elevated" />
                     </td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Errechnet: Gesamtumsatz bereinigt um die Mehrwertsteuer."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} value={calc.gesamtNetto || 0} formula={`Gesamt / ${(calc.activeMwstFaktor || 1).toFixed(2)}`} /></td>
                     <td className={`${tdPad} align-middle`}>{(calc.gesamtNetto || 0) > 0 && <UmsatzAmpelMitText umsatz={calc.gesamtNetto || 0} kostendeckung={calc.mindestNetto || 0} ruecklagenZielValue={(calc.mindestNetto || 0) * (1 + (calc.activeRuecklagenZielFaktor || 0))} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} istProzent={calc.prozent || 0} />}</td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Errechnet: Gesamtumsatz geteilt durch die produktiven Monatsstunden des Salons."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} value={calc.stdUmsatz || 0} formula="Gesamt / Std" decimalPlaces={0} /></td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Der absolut notwendige Netto-Mindestumsatz für diesen Monat (inkl. Außergewöhnliche Kosten)."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} value={calc.mindestNetto || 0} formula="Extern + A/E" /></td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Differenz zwischen dem erwirtschafteten Netto und dem Zielumsatz (Rücklagen)."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} value={calc.ruecklagenDelta || 0} formula="Netto - Mindest" isZielProzent zielProzentWert={calc.prozent || 0} /></td>
                     <td className={`${tdPad} border-r border-pe-border-strong bg-amber-950/10`} data-tooltip-id="app-tooltip" data-tooltip-content="Dein festgelegter Unternehmerlohn (inkl. Sozialkosten) für diesen Monat."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} value={calc.activePrivatentnahme || 0} formula="Privat" textColor="text-amber-700 dark:text-amber-500/80 font-bold" /></td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Der finale rechnerische Gewinn (Rücklagen-Delta + Privatentnahme)."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} value={calc.gewinn || 0} formula="Rücklagen + Privat" isZielProzent zielProzentWert={calc.prozent || 0} /></td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Die prozentuale Abweichung vom gesetzten Zielumsatz."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} value={calc.prozent || 0} formula="+/-" type="percentage" isZielProzent zielProzentWert={calc.prozent || 0} decimalPlaces={1} /></td>
                     
                     {hatVorjahresdaten && (
                        <>
                            <td className={`${tdPad} bg-pe-elevated`} data-tooltip-id="app-tooltip" data-tooltip-content="Vergleichswert: Netto-Umsatz aus dem Vorjahr.">
                                {isEditModeVJ ? (
                                    <div onPaste={(e) => onPasteVJ(i, 'vorjahrWert1', e)}>
                                        <EditableField variant="revenue" type="currency" currency={currencyCode} value={vorjahr.vorjahrWert1 || 0} onChange={(v) => updateVorjahr(i, 'vorjahrWert1', v)} className="bg-pe-card font-mono-numbers text-sm h-8 border-orange-500/30 text-orange-400" />
                                    </div>
                                ) : (
                                    <FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} formula="VJ Wert" value={vorjahr.vorjahrWert1 || 0} type="currency" highlightNegative bgColor="bg-pe-input" textColor="text-slate-500" />
                                )}
                            </td>
                            <td className={`${tdPad} bg-pe-elevated`} data-tooltip-id="app-tooltip" data-tooltip-content="Vergleichswert: Gewinn/Rücklagen aus dem Vorjahr.">
                                {isEditModeVJ ? (
                                    <div onPaste={(e) => onPasteVJ(i, 'vorjahrWert2', e)}>
                                        <EditableField variant="revenue" type="currency" currency={currencyCode} value={vorjahr.vorjahrWert2 || 0} onChange={(v) => updateVorjahr(i, 'vorjahrWert2', v)} className="bg-pe-card font-mono-numbers text-sm h-8 border-orange-500/30 text-orange-400" />
                                    </div>
                                ) : (
                                    <FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} formula="VJ Wert" value={vorjahr.vorjahrWert2 || 0} type="currency" highlightNegative bgColor="bg-pe-input" textColor="text-slate-500" />
                                )}
                            </td>
                            <td className={`${tdPad} bg-pe-elevated`} data-tooltip-id="app-tooltip" data-tooltip-content="Vergleichswert: Die Marge aus dem Vorjahr (Gewinn in Prozent vom Netto).">
                                <FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={calc.activeRuecklagenZielFaktor || 0} show={showFormulas} formula="VJ Marge" value={vorjahr.vorjahrProzent || 0} type="percentage" decimalPlaces={1} highlightNegative bgColor="bg-pe-input" textColor="text-slate-500" />
                            </td>
                        </>
                     )}

                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Eingabe: Einmalige außerordentliche Einnahmen oder Ausgaben in diesem Monat."><EditableField className="bg-pe-input border-stone-300 dark:border-white/10 text-stone-900 dark:text-white font-mono-numbers text-sm min-h-[34px] h-9" variant="revenue" type="currency" currency={currencyCode} value={m.aussergewoehnlich || 0} onChange={(v) => updateMonth(i, 'aussergewoehnlich', v)} readOnly={inputsLocked} /></td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Handelt es sich bei der Eingabe links um eine Ausgabe/Kosten (Häkchen AN) oder Einnahme (Häkchen AUS)?"><div className="flex justify-center items-center h-full"><input type="checkbox" checked={m.kostenErhoeht || false} onChange={(e) => updateMonth(i, 'kostenErhoeht', e.target.checked)} disabled={inputsLocked} className="form-checkbox h-5 w-5 text-orange-500 bg-pe-input dark:bg-black border-pe-border-strong dark:border-[#444] rounded focus:ring-orange-500 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed" /></div></td>
                     <td className="bg-[#222] border-l border-r border-[#111]"></td>
                     <td className={tdPad} data-tooltip-id="app-tooltip" data-tooltip-content="Schließt den Monat ab und friert die Basis-Kennzahlen für diesen Monat unwiderruflich ein."><div className="flex justify-center items-center h-full"><input type="checkbox" checked={m.abgeschlossen || false} onChange={() => onToggleLock(i)} disabled={rowHj1Locked} className="form-checkbox h-5 w-5 text-emerald-500 bg-pe-input dark:bg-black border-pe-border-strong dark:border-[#444] rounded focus:ring-emerald-500 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed" /></div></td>
                 </tr>
             </React.Fragment>
        );
    };
    
    const thBase = 'px-2 py-2 border-r border-pe-border-strong align-bottom leading-tight text-[10px] font-semibold uppercase tracking-wide text-pe-muted font-sans whitespace-normal';
    const HeaderCell: React.FC<React.ThHTMLAttributes<HTMLTableCellElement>> = ({ children, className = "", ...props }) => (<th className={`${thBase} text-center ${className}`} {...props}>{children}</th>);
    const SummaryCell: React.FC<{ children?: React.ReactNode, className?: string, 'data-tooltip-id'?: string, 'data-tooltip-content'?: string }> = ({ children, className = "", ...props }) => (<td className={`${tdPad} font-bold border-r border-pe-border-strong ${className}`} {...props}>{children}</td>);
    
    const summary = calculations?.gesamtjahr?.summary || {};
    const average = calculations?.gesamtjahr?.average || {};
    const umsatzauslastung = calculations?.gesamtjahr?.umsatzauslastung || 0;

    return (
        <div className="carbon-panel border border-pe-border-strong shadow-2xl bg-pe-card dark:bg-[#030303]">
            <div className="w-fit max-w-full overflow-x-auto pb-2 carbon-content">
             <table className="table-fixed text-center text-sm border-collapse bg-transparent" style={{ width: tableWidthPx }}>
                <colgroup>
                    <col style={{ width: W.monat }} />
                    <col style={{ width: W.team }} />
                    <col span={3} style={{ width: W.curr }} />
                    <col style={{ width: W.vk }} />
                    <col style={{ width: W.curr }} />
                    <col style={{ width: W.status }} />
                    <col style={{ width: W.std }} />
                    <col span={4} style={{ width: W.curr }} />
                    <col style={{ width: W.pct }} />
                    {hatVorjahresdaten && (<><col span={2} style={{ width: W.curr }} /><col style={{ width: W.pct }} /></>)}
                    <col style={{ width: W.ae }} />
                    <col style={{ width: W.chk }} />
                    <col style={{ width: W.sep }} />
                    <col style={{ width: W.fest }} />
                </colgroup>
                <thead className="bg-pe-elevated text-slate-400 border-b-2 border-pe-border-strong">
                    <tr className="border-b border-pe-border-strong">
                        <HeaderCell className="sticky left-0 bg-pe-elevated z-20 leading-snug" rowSpan={2}>Monat</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>Urlaub/<br/>Krank</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>Bedien-<br/>umsatz</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>VK-<br/>Umsatz</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>Gesamt-<br/>brutto</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>VK-<br/>Faktor</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>Gesamt-<br/>netto</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>Ziel-<br/>Status</HeaderCell>
                        <th className={`${thBase} text-center text-slate-300`} rowSpan={2}>UMSATZ<br/>P. STD.<span className="block text-orange-400 font-bold normal-case mt-0.5 font-mono-numbers text-[9px]">Soll: {formatCurrencyString(sollStundenUmsatzBrutto, currencyCode)}</span></th>
                        <HeaderCell className="leading-snug" rowSpan={2}>Mindest-<br/>netto</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>+/- Umsatz<br/>Rücklagen</HeaderCell>
                        <HeaderCell className="bg-amber-100 dark:bg-amber-950/20 text-amber-700 dark:text-amber-500 leading-snug" rowSpan={2}>Privat-<br/>entnahme</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>Gesamt-<br/>gewinn</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>Abweichung<br/>in %</HeaderCell>
                        {hatVorjahresdaten && <HeaderCell colSpan={3} className="text-center border-b border-pe-border-strong relative group bg-orange-100/60 dark:bg-orange-950/10">Vorjahr {isEditModeVJ && '(EDIT)'}</HeaderCell>}
                        <HeaderCell className="leading-snug" rowSpan={2}>Außerord.<br/>Ein-/Ausg.</HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>Kosten/<br/>Einnahme</HeaderCell>
                        <HeaderCell className="bg-[#222] border-l border-r border-[#111]" rowSpan={2}></HeaderCell>
                        <HeaderCell className="leading-snug" rowSpan={2}>Fest-<br/>machen</HeaderCell>
                    </tr>
                    <tr>{hatVorjahresdaten && (<><HeaderCell className="bg-orange-100/60 dark:bg-orange-950/10 leading-snug">Umsatz<br/>Netto</HeaderCell><HeaderCell className="bg-orange-100/60 dark:bg-orange-950/10 leading-snug">Gewinn/<br/>Rücklagen</HeaderCell><HeaderCell className="bg-orange-100/60 dark:bg-orange-950/10 leading-snug">Marge<br/>%</HeaderCell></>)}</tr>
                </thead>
                <tbody className="font-bold text-pe-text bg-transparent">{safeData.map((m, i) => renderRow(m as GesamtleistungMonatData, i))}</tbody>
                <tfoot className="font-bold text-sm border-t-4 border-pe-border-strong">
                    <tr className="bg-stone-100 dark:bg-[#050505] text-pe-text border-b border-pe-border dark:border-[#222]">
                        <SummaryCell className="sticky left-0 bg-pe-elevated z-10 text-left pl-2 font-sans text-xs uppercase tracking-widest text-slate-400">Gesamt</SummaryCell>
                        <SummaryCell></SummaryCell>
                        <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Summe aller Bedienumsätze im aktuellen Jahr."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="SUM(Bedien)" value={summary.bedienumsatzBrutto || 0} type="currency" bgColor="transparent" textColor="text-phantom-gold" /></SummaryCell>
                        <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Summe aller Verkaufsumsätze im aktuellen Jahr."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="SUM(VK)" value={summary.vkUmsatzBrutto || 0} type="currency" bgColor="transparent" textColor="text-phantom-gold" /></SummaryCell>
                        <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Summe aller Brutto-Gesamtumsätze im aktuellen Jahr."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="SUM(Gesamt)" value={summary.gesamtBrutto || 0} type="currency" bgColor="transparent" textColor="text-phantom-gold" /></SummaryCell>
                        <SummaryCell></SummaryCell>
                        <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Summe aller Netto-Gesamtumsätze im aktuellen Jahr."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="SUM(Netto)" value={summary.gesamtNetto || 0} type="currency" bgColor="transparent" textColor="text-phantom-gold" /></SummaryCell>
                        <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Ø Umsatzauslastung: Ziel ist 70-75%. < 50% ist kritisch."><div className="bg-pe-card p-1 rounded-lg text-center shadow-inner h-full flex flex-col justify-center border border-pe-border-strong cursor-help"><h4 className="text-[9px] uppercase tracking-widest text-slate-500 mb-1 font-sans">Ø Auslastung</h4><p className="text-base font-black text-phantom-gold tabular-nums font-mono-numbers led-gold">{formatPercentage(umsatzauslastung || 0, 1)}</p></div></SummaryCell>
                        <SummaryCell className="relative min-w-[120px]">
                            <div className="h-full flex flex-col justify-center text-[9px] uppercase tracking-wider text-left leading-tight space-y-1 pl-2 pointer-events-none font-bold">
                                <div className="text-slate-500 font-sans mb-1">Ziel: 70-75%</div>
                                <div className="text-purple-400 font-sans">≥ 85% = Exzellent</div>
                                <div className="text-emerald-400 font-sans">≥ 75% = Sehr Gut</div>
                                <div className="text-lime-400 font-sans">≥ 70% = Gut</div>
                                <div className="text-amber-400 font-sans">≥ 60% = Akzep.</div>
                                <div className="text-orange-400 font-sans">≥ 50% = Kritisch</div>
                                <div className="text-red-400 font-sans">&lt; 50% = Defizitär</div>
                            </div>
                        </SummaryCell>
                        <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Summe des Mindest-Nettoumsatzes."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="SUM(Mindest)" value={summary.mindestNetto || 0} type="currency" bgColor="transparent" textColor="text-phantom-gold" /></SummaryCell>
                        <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Summe der Abweichungen vom Planumsatz."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="SUM(Delta)" value={summary.ruecklagenDelta || 0} type="currency" isZielProzent zielProzentWert={summary.prozentSumme || 0} bgColor="transparent" /></SummaryCell>
                        <SummaryCell className="bg-amber-950/10" data-tooltip-id="app-tooltip" data-tooltip-content="Summe der Privatentnahmen/Unternehmerlohn."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="SUM(Privat)" value={summary.privatentnahme || 0} type="currency" bgColor="transparent" textColor="text-amber-500/80 font-bold" /></SummaryCell>
                        <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Summe aller berechneten Gewinne."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="SUM(Gewinn)" value={summary.gewinn || 0} type="currency" isZielProzent zielProzentWert={summary.prozentSumme || 0} bgColor="transparent" /></SummaryCell>
                        <SummaryCell><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} value={summary.prozentSumme || 0} type="percentage" isZielProzent zielProzentWert={summary.prozentSumme || 0} decimalPlaces={1} bgColor="transparent" formula="Summe aller %" /></SummaryCell>
                        {hatVorjahresdaten && (<><SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Summe Vorjahres-Umsatz."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="SUM(VJ 1)" value={summary.vorjahrWert1 || 0} type="currency" highlightNegative bgColor="bg-pe-input" textColor="text-slate-500" /></SummaryCell><SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Summe Vorjahres-Gewinn."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="SUM(VJ 2)" value={summary.vorjahrWert2 || 0} type="currency" highlightNegative bgColor="bg-pe-input" textColor="text-slate-500" /></SummaryCell><SummaryCell><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} value={summary.totalVorjahrProzentSumme || 0} type="percentage" highlightNegative bgColor="bg-pe-input" textColor="text-slate-500" formula="Summe VJ %" decimalPlaces={1} /></SummaryCell></>)}
                        <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Summe der außergewöhnlichen Einnahmen/Ausgaben."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} value={summary.aussergewoehnlich || 0} type="currency" bgColor="transparent" textColor="text-slate-400" formula="SUM(A/E)" /></SummaryCell>
                        <SummaryCell></SummaryCell><SummaryCell className="bg-[#222] border-l border-r border-[#111]"></SummaryCell><SummaryCell></SummaryCell>
                    </tr>
                     <tr className="bg-pe-card text-pe-text">
                         <SummaryCell className="sticky left-0 bg-pe-elevated z-10 text-left pl-2 font-sans text-xs uppercase tracking-widest text-slate-400">Durchschnitt</SummaryCell>
                         <SummaryCell></SummaryCell>
                         <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Bedienumsatz."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(Bedien)" value={average.bedienumsatzBrutto || 0} type="currency" bgColor="transparent" textColor="text-phantom-gold" /></SummaryCell>
                         <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Verkaufsumsatz."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(VK)" value={average.vkUmsatzBrutto || 0} type="currency" bgColor="transparent" textColor="text-phantom-gold" /></SummaryCell>
                         <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Gesamtumsatz."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(Gesamt)" value={average.gesamtBrutto || 0} type="currency" bgColor="transparent" textColor="text-phantom-gold" /></SummaryCell>
                         <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Verkaufsfaktor."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(VK %)" value={(average.vkFaktor || 0) / 100} type="percentage" decimalPlaces={1} bgColor="transparent" textColor={getVkFaktorColor(average.vkFaktor || 0)} /></SummaryCell>
                         <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Netto-Umsatz."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(Netto)" value={average.gesamtNetto || 0} type="currency" bgColor="transparent" textColor="text-phantom-gold" /></SummaryCell>
                         <SummaryCell><UmsatzAmpelMitText umsatz={average.gesamtNetto || 0} kostendeckung={average.mindestNetto || 0} ruecklagenZielValue={(average.mindestNetto || 0) * (1 + safeRuecklagenZiel)} ruecklagenZielFaktor={safeRuecklagenZiel} istProzent={average.prozent || 0} /></SummaryCell>
                         <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Stundenumsatz."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(Std)" value={average.stdUmsatz || 0} type="currency" decimalPlaces={0} bgColor="transparent" textColor="text-orange-400" /></SummaryCell>
                         <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Mindestumsatz."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(Mindest)" value={average.mindestNetto || 0} type="currency" bgColor="transparent" textColor="text-phantom-gold" /></SummaryCell>
                         <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittliche Planabweichung."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(Delta)" value={average.ruecklagenDelta || 0} type="currency" isZielProzent zielProzentWert={average.prozent || 0} bgColor="transparent" /></SummaryCell>
                         <SummaryCell className="bg-amber-950/10" data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittliche Privatentnahme."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(Privat)" value={average.privatentnahme || 0} type="currency" bgColor="transparent" textColor="text-amber-500/80 font-bold" /></SummaryCell>
                         <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher monatlicher Gewinn."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(Gewinn)" value={average.gewinn || 0} type="currency" isZielProzent zielProzentWert={average.prozent || 0} bgColor="transparent" /></SummaryCell>
                         <SummaryCell><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(Monat%)" value={average.prozent || 0} type="percentage" isZielProzent zielProzentWert={average.prozent || 0} decimalPlaces={1} bgColor="transparent" /></SummaryCell>
                         {hatVorjahresdaten && (<><SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Vorjahresumsatz."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(VJ 1)" value={average.vorjahrWert1 || 0} type="currency" highlightNegative bgColor="bg-pe-input" textColor="text-slate-500" /></SummaryCell><SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Vorjahresgewinn."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(VJ 2)" value={average.vorjahrWert2 || 0} type="currency" highlightNegative bgColor="bg-pe-input" textColor="text-slate-500" /></SummaryCell><SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittliche Vorjahresmarge."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(VJ %)" value={average.vorjahrProzent || 0} type="percentage" highlightNegative bgColor="bg-pe-input" textColor="text-slate-500" decimalPlaces={1} /></SummaryCell></>)}
                         <SummaryCell data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittliche außergewöhnliche E/A."><FormulaDisplay currency={currencyCode} ruecklagenZielFaktor={safeRuecklagenZiel} show={showFormulas} formula="AVG(A/E)" value={average.aussergewoehnlich || 0} type="currency" bgColor="transparent" textColor="text-slate-400" /></SummaryCell>
                         <SummaryCell></SummaryCell><SummaryCell className="bg-[#222] border-l border-r border-[#111]"></SummaryCell><SummaryCell></SummaryCell>
                      </tr>
                 </tfoot>
             </table>
            </div>
        </div>
    );
};

const GesamtleistungSeite: React.FC = () => {
    const [hatVorjahresdaten, setHatVorjahresdaten] = useState(() => {
        const saved = localStorage.getItem('pe_show_prior_year');
        return saved !== null ? JSON.parse(saved) : true;
    });

    const [vorjahresDaten, setVorjahresDaten] = useState(() => {
        const saved = localStorage.getItem('pe_vorjahres_daten_v4');
        return saved !== null ? JSON.parse(saved) : vorjahresDatenLeer;
    });

    const [isEditModeVJ, setIsEditModeVJ] = useState(false);
    const [isSummaryOpen, setIsSummaryOpen] = useState(false);
    const [isComparisonOpen, setIsComparisonOpen] = useState(false);

    const impersonatedClientId = useAdminStore(state => state.impersonatedClientId);

    useEffect(() => {
        const safeId = (impersonatedClientId === "undefined" || impersonatedClientId === "null") ? null : impersonatedClientId;
        const targetUid = safeId || auth.currentUser?.uid;
        if (!targetUid) return;

        const unsub = onSnapshot(doc(db, 'kalkulation_mandanten', targetUid), (docSnap) => {
            // Minimaler Snapshot-Listener
        }, (error) => {
            console.error("FATAL: Listener abgestürzt, Loop verhindert:", error);
        });
        return () => unsub();
    }, [impersonatedClientId]);

    useEffect(() => {
        localStorage.setItem('pe_show_prior_year', JSON.stringify(hatVorjahresdaten));
    }, [hatVorjahresdaten]);

    useEffect(() => {
        localStorage.setItem('pe_vorjahres_daten_v4', JSON.stringify(vorjahresDaten));
    }, [vorjahresDaten]);

    const [passwordModal, setPasswordModal] = useState({ isOpen: false, onConfirm: (pw: string) => {}, error: '' });
    const [festSessionUnlocked, setFestSessionUnlocked] = useState(false);

    // 💉 CHIRURGIE-FIX: Daten werden aus useShallow entkoppelt, damit Zustand bei jedem Array-Update die Seite rendert.
    const gesamtleistungData = useAppStore(state => state.clientData?.gesamtleistungData);
    const unternehmerData = useAppStore(state => state.clientData?.unternehmerData);

    const { 
        clientData, 
        settings, 
        showFormulas, 
        updateGesamtleistungMonat, 
        gesamtleistungSettings, 
        urlaubsverlustData, 
        updateGesamtleistungSetting, 
        updateUrlaubsverlustMonat, 
        mitarbeiterLeistung, 
        isHJ2Freigegeben, 
        isHJ1GesperrtGlobal,
        ulHalbjahr1, 
        ulHalbjahr2, 
        setClientData,
        updateSettings,
        captureState
    } = useAppStore(useShallow(state => ({
        clientData: state.clientData,
        settings: state.settings,
        showFormulas: state.showFormulas,
        updateGesamtleistungMonat: state.updateGesamtleistungMonat,
        gesamtleistungSettings: state.clientData?.gesamtleistungSettings || { planStundenTag: 8 },
        urlaubsverlustData: state.clientData?.urlaubsverlustData || [],
        updateGesamtleistungSetting: state.updateGesamtleistungSetting,
        updateUrlaubsverlustMonat: state.updateUrlaubsverlustMonat,
        mitarbeiterLeistung: state.clientData?.mitarbeiterLeistung,
        isHJ2Freigegeben: state.clientData?.isHJ2Freigegeben,
        isHJ1GesperrtGlobal: state.clientData?.isHJ1GesperrtGlobal,
        ulHalbjahr1: state.clientData?.ulHalbjahr1,
        ulHalbjahr2: state.clientData?.ulHalbjahr2,
        setClientData: state.setClientData,
        updateSettings: state.updateSettings,
        captureState: state.captureState
    })));
    
    const isGodMode = !!useAdminStore((s) => s.impersonatedClientId);
    const hj1ClientLocked = isHj1ClientLocked({ isHJ1GesperrtGlobal, isHJ2Freigegeben });
    const hj1LockedForUi = hj1ClientLocked;

    const calculationsStore = useCalculationsSelector();
    const currencyCode = calculationsStore?.currencyCode || settings?.country?.currency || 'EUR';
    const effectiveVatRate = calculationsStore?.mwstSatz !== undefined
        ? Number(calculationsStore.mwstSatz)
        : (clientData?.isVatExempt ? 0 : (settings?.country?.MwSt_Satz || 19));
    const mwstFaktor = 1 + effectiveVatRate / 100;
    const personalData = useMemo(() => calculationsStore?.personalData ?? [], [calculationsStore]);
    
    const isMultiFounder = clientData?.personengesellschaft?.aktiv;
    const pgPartner = clientData?.personengesellschaft?.partner;
    const partnerData = useMemo(() => pgPartner || [], [pgPartner]);
    
    const isSoloActive = isSoloModeActive(clientData);
    const isBaseActive = clientData?.basicChecked === true || clientData?.lizenzDetails?.typ === 'basic' || clientData?.lizenzDetails?.typ === 'base';
    
    const showTeamData = !isSoloActive && !isBaseActive;

    const ruecklagenZielFaktor = (settings?.global?.Liquiditaet || 0) / 100;
    const auslastungsFaktor = settings?.global?.Auslastungsfaktor || 75;

    // GbR-Weiche: Privatentnahme/Unternehmerlohn aus Partner-Summe, sonst unternehmerData
    const gesamtUnternehmerlohn = useMemo(() => {
        const pgAktiv =
            clientData?.personengesellschaft?.aktiv === true &&
            Array.isArray(partnerData) &&
            partnerData.length > 0;

        if (pgAktiv) {
            return partnerData.reduce((sum: number, p: any) => {
                return sum + (Number(p?.entnahme) || 0) + (Number(p?.sozialkosten) || 0);
            }, 0);
        }

        return (unternehmerData?.entnahme || 0) + (unternehmerData?.sozialkosten || 0);
    }, [clientData?.personengesellschaft?.aktiv, partnerData, unternehmerData?.entnahme, unternehmerData?.sozialkosten]);

    const unternehmerGeoeffneteStunden = unternehmerData?.geoeffneteStunden;
    const unternehmerProdWochentage = unternehmerData?.prodWochentage;
    const globalWochensatz = settings?.global?.Wochensatz;
    const globalAuslastungsfaktor = settings?.global?.Auslastungsfaktor;

    const { MONATSSTUNDEN, ARBEITSTAGE_PRO_MONAT } = useMemo(() => {
        const wochenstunden = (unternehmerGeoeffneteStunden || []).reduce((sum: number, h: any) => sum + (Number(h) || 0), 0);
        const monatsStunden = wochenstunden * (globalWochensatz || 4.33);
        const arbeitstageProMonat = (unternehmerProdWochentage || 0) * (globalWochensatz || 4.33);
        return { MONATSSTUNDEN: monatsStunden || 1, ARBEITSTAGE_PRO_MONAT: arbeitstageProMonat || 1 };
    }, [unternehmerGeoeffneteStunden, unternehmerProdWochentage, globalWochensatz]);

    const lfMindestumsatz1 = clientData?.lohnfaktorData?.mindestumsatz1;
    const lfMindestumsatz2 = clientData?.lohnfaktorData?.mindestumsatz2;
    const calcStoreSoll = calculationsStore?.sollumsatz;

    const calculations = useMemo(() => {
        const baseMindestumsatzNetto = calcStoreSoll || 0; 
        const mindestumsatz1 = lfMindestumsatz1 || baseMindestumsatzNetto;
        const mindestumsatz2 = lfMindestumsatz2 || baseMindestumsatzNetto;
        const privatentnahme = gesamtUnternehmerlohn;

        const calculateWerte = (data: GesamtleistungMonatData[]) => {
              const safeDataForCalc = monthNames.map((n, i) => data?.[i] || { monat: n, bedienumsatzBrutto: 0, vkUmsatzBrutto: 0, aussergewoehnlich: 0, kostenErhoeht: false, abgeschlossen: false });

              const monatsDetails = safeDataForCalc.map((monat, index) => {
                  const isLocked = monat.abgeschlossen === true;
                  const snap = monat.frozenCalculations || {};

                  const currentBaseMindestumsatz = index < 6 ? mindestumsatz1 : mindestumsatz2;
                  
                  const activeMindestumsatzBase = (isLocked && snap.mindestumsatzBase !== undefined) ? snap.mindestumsatzBase : currentBaseMindestumsatz;
                  const activeMwstFaktor = (isLocked && snap.mwstFaktor !== undefined) ? snap.mwstFaktor : mwstFaktor;
                  const activePrivatentnahme = (isLocked && snap.privatentnahme !== undefined) ? snap.privatentnahme : privatentnahme;
                  const activeMonatsstunden = (isLocked && snap.monatsstunden !== undefined) ? snap.monatsstunden : MONATSSTUNDEN;
                  const activeRuecklagenZielFaktor = (isLocked && snap.ruecklagenZielFaktor !== undefined) ? snap.ruecklagenZielFaktor : ruecklagenZielFaktor;

                  const anpassungsFaktor = monat.kostenErhoeht ? -1 : 1;
                  const angepassterMindestumsatz = activeMindestumsatzBase + ((monat.aussergewoehnlich || 0) * anpassungsFaktor);
                  
                  const gesamtBrutto = (monat.bedienumsatzBrutto || 0) + (monat.vkUmsatzBrutto || 0);
                  
                  if (gesamtBrutto === 0) { 
                      return { 
                          gesamtBrutto: 0, vkFaktor: 0, stdUmsatz: 0, gesamtNetto: 0, mindestNetto: angepassterMindestumsatz, ruecklagenDelta: 0, gewinn: 0, prozent: 0, 
                          activeMwstFaktor, activePrivatentnahme, activeMonatsstunden, activeRuecklagenZielFaktor 
                      }; 
                  }
                  
                  const gesamtNetto = safeDiv(gesamtBrutto, activeMwstFaktor);
                  const ruecklagenDelta = gesamtNetto - angepassterMindestumsatz;
                  const gewinn = ruecklagenDelta + activePrivatentnahme;
                  const prozent = safeDiv(ruecklagenDelta, angepassterMindestumsatz);
                  
                  return { 
                      gesamtBrutto, 
                      vkFaktor: safeDiv(monat.vkUmsatzBrutto, monat.bedienumsatzBrutto) * 100, 
                      stdUmsatz: safeDiv(gesamtBrutto, activeMonatsstunden), 
                      gesamtNetto, 
                      mindestNetto: angepassterMindestumsatz, 
                      ruecklagenDelta, 
                      gewinn, 
                      prozent, 
                      activeMwstFaktor, activePrivatentnahme, activeMonatsstunden, activeRuecklagenZielFaktor 
                  };
               });
             return { monatsDetails, halbjahr1: { monatsDetails: monatsDetails.slice(0, 6) }, halbjahr2: { monatsDetails: monatsDetails.slice(6, 12) } };
        };
        
         const { monatsDetails, halbjahr1, halbjahr2 } = calculateWerte(gesamtleistungData || []);
         
         const rawData = monthNames.map((n, i) => gesamtleistungData?.[i] || { monat: n, bedienumsatzBrutto: 0, vkUmsatzBrutto: 0, aussergewoehnlich: 0, kostenErhoeht: false, abgeschlossen: false });
         
         const summary = monatsDetails.reduce((acc, curr, i) => {
             const monat = rawData[i];
             const isActive = monat.bedienumsatzBrutto > 0 || monat.vkUmsatzBrutto > 0 || monat.abgeschlossen;
             
             if (isActive) {
                 acc.activeMonths++;
                 acc.bedienumsatzBrutto += monat.bedienumsatzBrutto || 0;
                 acc.vkUmsatzBrutto += monat.vkUmsatzBrutto || 0;
                 acc.gesamtBrutto += curr.gesamtBrutto || 0;
                 acc.gesamtNetto += curr.gesamtNetto || 0;
                 acc.mindestNetto += curr.mindestNetto || 0;
                 acc.ruecklagenDelta += curr.ruecklagenDelta || 0;
                 acc.privatentnahme += (curr.activePrivatentnahme !== undefined ? curr.activePrivatentnahme : privatentnahme);
                 acc.gewinn += curr.gewinn || 0;
                 acc.aussergewoehnlich += monat.aussergewoehnlich || 0;
                 acc.prozentSumme += curr.prozent || 0;
                 acc.monatsstundenSumme += curr.activeMonatsstunden || MONATSSTUNDEN;
             }
             
             const vorjahr = vorjahresDaten?.[i] || { vorjahrWert1: 0, vorjahrWert2: 0, vorjahrProzent: 0 };
             const isVJActive = vorjahr.vorjahrWert1 > 0 || vorjahr.vorjahrWert2 > 0;
             if (isVJActive) {
                 acc.activeMonthsVJ++;
                 acc.vorjahrWert1 += vorjahr.vorjahrWert1 || 0;
                 acc.vorjahrWert2 += vorjahr.vorjahrWert2 || 0;
                 acc.totalVorjahrProzentSumme += vorjahr.vorjahrProzent || 0;
             }
             
             return acc;
         }, { bedienumsatzBrutto: 0, vkUmsatzBrutto: 0, gesamtBrutto: 0, gesamtNetto: 0, mindestNetto: 0, ruecklagenDelta: 0, privatentnahme: 0, gewinn: 0, vorjahrWert1: 0, vorjahrWert2: 0, aussergewoehnlich: 0, prozentSumme: 0, totalVorjahrProzentSumme: 0, activeMonths: 0, activeMonthsVJ: 0, monatsstundenSumme: 0 });
         
         const safeMonths = summary.activeMonths || 1;
         const safeMonthsVJ = summary.activeMonthsVJ || 1;
         
         const average = {
             bedienumsatzBrutto: safeDiv(summary.bedienumsatzBrutto, safeMonths),
             vkUmsatzBrutto: safeDiv(summary.vkUmsatzBrutto, safeMonths),
             gesamtBrutto: safeDiv(summary.gesamtBrutto, safeMonths),
             vkFaktor: safeDiv(summary.vkUmsatzBrutto, summary.bedienumsatzBrutto) * 100,
             stdUmsatz: safeDiv(summary.gesamtBrutto, summary.monatsstundenSumme || MONATSSTUNDEN * safeMonths),
             gesamtNetto: safeDiv(summary.gesamtNetto, safeMonths),
             mindestNetto: safeDiv(summary.mindestNetto, safeMonths),
             ruecklagenDelta: safeDiv(summary.ruecklagenDelta, safeMonths),
             privatentnahme: safeDiv(summary.privatentnahme, safeMonths),
             gewinn: safeDiv(summary.gewinn, safeMonths),
             prozent: safeDiv(summary.prozentSumme, safeMonths),
             vorjahrWert1: safeDiv(summary.vorjahrWert1, safeMonthsVJ),
             vorjahrWert2: safeDiv(summary.vorjahrWert2, safeMonthsVJ),
             aussergewoehnlich: safeDiv(summary.aussergewoehnlich, safeMonths),
             vorjahrProzent: safeDiv(summary.totalVorjahrProzentSumme, safeMonthsVJ)
         };
         
         const korrekterSollStundenUmsatzBrutto = safeDiv(baseMindestumsatzNetto * (1 + ruecklagenZielFaktor), MONATSSTUNDEN) * mwstFaktor;
         return { halbjahr1, halbjahr2, gesamtjahr: { summary, average, umsatzauslastung: (auslastungsFaktor / 100) * safeDiv(average.stdUmsatz, korrekterSollStundenUmsatzBrutto) } };
    }, [gesamtleistungData, lfMindestumsatz1, lfMindestumsatz2, calcStoreSoll, gesamtUnternehmerlohn, MONATSSTUNDEN, mwstFaktor, ruecklagenZielFaktor, auslastungsFaktor, vorjahresDaten]);

    const storeMetrics = calculationsStore?.unternehmerMetrics;
    const avgNetto = calculations?.gesamtjahr?.average?.gesamtNetto || 0;
    const avgMindestNetto = calculations?.gesamtjahr?.average?.mindestNetto || 0;
    const avgVkFaktor = calculations?.gesamtjahr?.average?.vkFaktor || 0;
    const calcUmsatzauslastung = calculations?.gesamtjahr?.umsatzauslastung || 0;

    const unternehmerMetrics = useMemo(() => {
        let eff = storeMetrics?.efficiency;
        if (!eff || eff === 0) {
            const zielNetto = avgMindestNetto * (1 + ruecklagenZielFaktor);
            eff = safeDiv(avgNetto, zielNetto);
        }

        let auslastung = storeMetrics?.umsatzauslastung;
        if (auslastung && auslastung > 0 && auslastung <= 2) {
            auslastung = auslastung * 100;
        } else if (!auslastung || auslastung === 0) {
            auslastung = calcUmsatzauslastung * 100;
        }

        let vk = storeMetrics?.vkFaktor;
        if (!vk || vk === 0) {
            vk = avgVkFaktor / 100;
        }

        return {
            efficiency: eff,
            umsatzauslastung: auslastung,
            vkFaktor: vk,
            sumKrankTage: storeMetrics?.sumKrankTage || 0
        };
    }, [storeMetrics, avgNetto, avgMindestNetto, avgVkFaktor, calcUmsatzauslastung, ruecklagenZielFaktor]);

    const fallbackML = calculationsStore?.calculatedMitarbeiterLeistung;
    const lohnfaktorAktiv = calculationsStore?.lohnfaktorAktiv;
    const geraeteListe = calculationsStore?.geraeteListe;

    const effectiveMitarbeiterLeistung = useMemo(() => {
        const fallback = fallbackML || {};
        const result: Record<string, any> = {};
        
        if (!personalData || !mitarbeiterLeistung) return fallback;
        
        const wochensatz = globalWochensatz || 4.33;
        const currentLohnfaktorAktiv = lohnfaktorAktiv || 0;
        const currentGeraeteListe = Array.isArray(geraeteListe) ? geraeteListe : [];
        
        personalData.forEach((ma: EmployeeData) => {
            const leistungData = mitarbeiterLeistung[ma.id];
            if (!leistungData) {
                result[ma.id] = fallback[ma.id] || {};
                return;
            }
            
            const basisdaten = ma as any;
            const wochenstunden = basisdaten.wochenstunden || 0;
            const arbeitstage = basisdaten.arbeitstage || 5;
            
            if (wochenstunden === 0 || arbeitstage === 0) {
                result[ma.id] = fallback[ma.id] || {};
                return;
            }

            const monatsStunden = wochenstunden * wochensatz;
            const tagesArbeitszeit = wochenstunden / arbeitstage;
            
            const effektiverBruttolohn = (basisdaten.grundgehalt || 0) + (basisdaten.lohnkostenzusatz || basisdaten.lohnzusatz || 0);
            
            let currentLohnfaktor = currentLohnfaktorAktiv;
            const safeDeviceIds = Array.isArray(leistungData.selectedDeviceIds) ? leistungData.selectedDeviceIds : [];
            
            if (basisdaten.arbeitetMitGeraeten && safeDeviceIds.length > 0) {
                let totalGeraeteProzent = 0;
                safeDeviceIds.forEach((devId: string) => {
                    const geraet = currentGeraeteListe.find((g: any) => g && g.id === devId);
                    if (geraet) {
                        totalGeraeteProzent += (geraet.kostenProzent || 0);
                    }
                });
                const faktorZuschlag = (totalGeraeteProzent / 100) * 10;
                currentLohnfaktor += faktorZuschlag;
            }
            
            const sollUmsatzMonat = effektiverBruttolohn * currentLohnfaktor;
            const sollUmsatzProStunde = safeDiv(sollUmsatzMonat, monatsStunden);
            const auslastungVorgabe = 75;
            const kostendeckungsfaktor =
                Number(clientData?.lohnfaktorData?.kostendeckungsfaktor1) > 0
                    ? Number(clientData.lohnfaktorData.kostendeckungsfaktor1)
                    : 2.8;
            const kostendeckungsumsatz = effektiverBruttolohn * kostendeckungsfaktor;
            
            const processHj = (hjData: any[] | undefined) => {
                if (!Array.isArray(hjData)) return { auslastungSum: 0, vkFaktorSum: 0, effSum: 0, umsatzSum: 0, count: 0, krank: 0 };
                
                let auslastungSum = 0, vkFaktorSum = 0, effSum = 0, umsatzSum = 0, count = 0, krank = 0;
                let summeIstUmsatz = 0, anzahlMonateMitUmsatz = 0;
                
                hjData.forEach(m => {
                    const bedien = m?.bedienUmsatz || 0;
                    const vk = m?.vkUmsatz || 0;
                    if ((bedien + vk) > 0) {
                        summeIstUmsatz += (bedien + vk);
                        anzahlMonateMitUmsatz++;
                    }
                });
                
                const avgIstUmsatzMonat = anzahlMonateMitUmsatz > 0 ? summeIstUmsatz / anzahlMonateMitUmsatz : 0;
                const avgIstUmsatzProStunde = safeDiv(avgIstUmsatzMonat, monatsStunden);
                
                hjData.forEach(m => {
                    const bedien = m?.bedienUmsatz || 0;
                    const vk = m?.vkUmsatz || 0;
                    krank += (Number(m?.krankheitsTage) || 0);
                    
                    const gesamtIst = bedien + vk;
                    if (gesamtIst > 0) { 
                        count++;
                        const uTage = Number(m?.urlaubsTage) || 0;
                        const urlaubsAusgleich = avgIstUmsatzProStunde * uTage * tagesArbeitszeit;
                        const gesamtUmsatzBrutto = gesamtIst + urlaubsAusgleich;
                        umsatzSum += gesamtUmsatzBrutto;
                        
                        const umsatzProStunde = safeDiv(gesamtUmsatzBrutto, monatsStunden);
                        auslastungSum += (auslastungVorgabe / 100) * safeDiv(umsatzProStunde, sollUmsatzProStunde) * 100;
                        vkFaktorSum += safeDiv(vk, bedien);
                        
                        let angepassterSollUmsatz = sollUmsatzMonat;
                        if (!m?.ueberstundenAuszahlen) {
                            angepassterSollUmsatz -= ((Number(m?.unproduktiveStunden) || 0) * sollUmsatzProStunde);
                        }
                        effSum += safeDiv(gesamtUmsatzBrutto, angepassterSollUmsatz);
                    }
                });
                
                return { auslastungSum, vkFaktorSum, effSum, umsatzSum, count, krank };
            };

            /** HJ-Ampel = Umsatzziel (wie LeistungPage): ≥ Soll ok, ≥ Kostendeckung warnung, sonst schlecht */
            const statusFromZiel = (umsatzSum: number, count: number): MitarbeiterStatus => {
                if (count <= 0) return 'neutral';
                const avgUmsatz = umsatzSum / count;
                if (avgUmsatz <= 0) return 'neutral';
                if (avgUmsatz >= sollUmsatzMonat) return 'ok';
                if (avgUmsatz >= kostendeckungsumsatz) return 'warnung';
                return 'schlecht';
            };
            
            const hj1 = processHj(leistungData.halbjahr1 || []);
            const hj2 = processHj(leistungData.halbjahr2 || []);
            
            const totalCount = hj1.count + hj2.count;
            const oldMetrics = fallback[ma.id] || {};
            
            if (totalCount > 0) {
                result[ma.id] = {
                    ...oldMetrics,
                    calculatedAvgUmsatzauslastung: (hj1.auslastungSum + hj2.auslastungSum) / totalCount,
                    calculatedAvgVkFaktor: (hj1.vkFaktorSum + hj2.vkFaktorSum) / totalCount,
                    calculatedAvgEfficiency: (hj1.effSum + hj2.effSum) / totalCount,
                    calculatedSumKrankTage: hj1.krank + hj2.krank,
                    calculatedStatusHJ1: statusFromZiel(hj1.umsatzSum, hj1.count),
                    calculatedStatusHJ2: statusFromZiel(hj2.umsatzSum, hj2.count),
                };
            } else {
                result[ma.id] = {
                    ...oldMetrics,
                    calculatedAvgUmsatzauslastung: 0,
                    calculatedAvgVkFaktor: 0,
                    calculatedAvgEfficiency: 0,
                    calculatedSumKrankTage: hj1.krank + hj2.krank,
                    calculatedStatusHJ1: 'neutral',
                    calculatedStatusHJ2: 'neutral',
                };
            }
        });
        
        return result;
    }, [personalData, mitarbeiterLeistung, globalWochensatz, fallbackML, lohnfaktorAktiv, geraeteListe, clientData?.lohnfaktorData?.kostendeckungsfaktor1]);

    const unternehmername = clientData?.unternehmername;

    const founderRows = useMemo(() => {
        if (!isMultiFounder) {
            return [{
                id: 'chef',
                name: unternehmername || 'Unternehmer (Chef)',
                metrics: unternehmerMetrics
            }];
        }

        return partnerData.map((p: any) => {
            let bedienSum = 0;
            let vkSum = 0;
            let krankSum = 0;
            let effSum = 0;
            let auslastungSum = 0;
            let count = 0;

            const wochenstunden = p.prodWochenstunden || 0;
            const monatsstunden = wochenstunden * (globalWochensatz || 4.33);

            let expectedBrutto = p.durchschnittsumsatz || 0;
            if (expectedBrutto === 0) {
                const activeMonths = (p.monatsUmsaetze || []).filter((m: number) => m > 0);
                expectedBrutto = activeMonths.length > 0 ? activeMonths.reduce((a: number,b: number)=>a+b,0)/activeMonths.length : 0;
            }
            const sollumsatzPStd = monatsstunden > 0 ? expectedBrutto / monatsstunden : 0;
            const auslastungsVorgabe = (globalAuslastungsfaktor || 75) / 100;

            const processHj = (hj: any[]) => {
                if (!Array.isArray(hj)) return;
                hj.forEach(m => {
                    const b = m.bedienumsatzBrutto || 0;
                    const v = m.vkUmsatzBrutto || 0;
                    krankSum += (Number(m.krankheitsTage) || 0);
                    const gesamt = b + v;
                    if (gesamt > 0) {
                        count++;
                        bedienSum += b;
                        vkSum += v;
                        
                        if (expectedBrutto > 0) effSum += gesamt / expectedBrutto;
                        
                        const umsatzPStd = monatsstunden > 0 ? gesamt / monatsstunden : 0;
                        if (sollumsatzPStd > 0) auslastungSum += (umsatzPStd / sollumsatzPStd) * auslastungsVorgabe;
                    }
                });
            };

            processHj(p.ulHalbjahr1);
            processHj(p.ulHalbjahr2);

            return {
                id: p.id,
                name: p.name || 'Partner',
                metrics: {
                    efficiency: count > 0 ? effSum / count : 0,
                    vkFaktor: bedienSum > 0 ? vkSum / bedienSum : 0,
                    sumKrankTage: krankSum,
                    umsatzauslastung: count > 0 ? auslastungSum / count : 0
                }
            };
        });
    }, [isMultiFounder, partnerData, unternehmername, unternehmerMetrics, globalWochensatz, globalAuslastungsfaktor]);

    const teamStats = useMemo(() => {
        const stats = Array(12).fill(0).map(() => ({ urlaub: 0, krank: 0 }));
        if (personalData && mitarbeiterLeistung) {
            personalData.forEach((ma: EmployeeData) => {
                const leistung = mitarbeiterLeistung[ma.id];
                if (!leistung) return;
                leistung.halbjahr1?.forEach((m: any, i: number) => { if (i < 6) { stats[i].urlaub += m.urlaubsTage || 0; stats[i].krank += m.krankheitsTage || 0; } });
                leistung.halbjahr2?.forEach((m: any, i: number) => { if (i < 6) { stats[i + 6].urlaub += m.urlaubsTage || 0; stats[i + 6].krank += m.krankheitsTage || 0; } });
            });
        }
        
        if (isMultiFounder) {
            partnerData.forEach((p: any) => {
                if (p.ulHalbjahr1) p.ulHalbjahr1.forEach((m: any, i: number) => { if (i < 6) { stats[i].urlaub += m.urlaubsTage || 0; stats[i].krank += m.krankheitsTage || 0; } });
                if (p.ulHalbjahr2) p.ulHalbjahr2.forEach((m: any, i: number) => { if (i < 6) { stats[i + 6].urlaub += m.urlaubsTage || 0; stats[i + 6].krank += m.krankheitsTage || 0; } });
            });
        } else {
            if (ulHalbjahr1) { ulHalbjahr1.forEach((m, i) => { if (i < 6) { stats[i].urlaub += m.urlaubsTage || 0; stats[i].krank += m.krankheitsTage || 0; } }); }
            if (ulHalbjahr2) { ulHalbjahr2.forEach((m, i) => { if (i < 6) { stats[i + 6].urlaub += m.urlaubsTage || 0; stats[i + 6].krank += m.krankheitsTage || 0; } }); }
        }
        
        return stats;
    }, [personalData, mitarbeiterLeistung, ulHalbjahr1, ulHalbjahr2, isMultiFounder, partnerData]);

    // Patient Zero: H1/H2-Aggregation aus bestehenden monatsDetails + teamStats (kein Eingriff in MonatsTabelle)
    const h1h2Comparison = useMemo(() => {
        const rawMonths = monthNames.map((n, i) => gesamtleistungData?.[i] || {
            monat: n, bedienumsatzBrutto: 0, vkUmsatzBrutto: 0, aussergewoehnlich: 0, kostenErhoeht: false, abgeschlossen: false, frozenCalculations: null,
        });
        const detailsFull = [
            ...(calculations?.halbjahr1?.monatsDetails || []),
            ...(calculations?.halbjahr2?.monatsDetails || []),
        ];
        const baseMindestumsatzNetto = calcStoreSoll || 0;
        const korrekterSollStundenUmsatzBrutto =
            safeDiv(baseMindestumsatzNetto * (1 + ruecklagenZielFaktor), MONATSSTUNDEN) * mwstFaktor;

        const resolveAmpel = (
            avgNetto: number,
            avgMindest: number,
            activeMonths: number
        ): H1H2AmpelStatus => {
            if (!activeMonths || avgNetto <= 0) return 'keine_daten';
            if (avgNetto < avgMindest) return 'nicht_kostendeckend';
            if (avgNetto < avgMindest * (1 + ruecklagenZielFaktor)) return 'kostendeckend';
            return 'ziel_erreicht';
        };

        const buildHalf = (label: 'H1' | 'H2', startIdx: number): H1H2HalfMetrics => {
            let activeMonths = 0;
            let umsatzNettoSumme = 0;
            let umsatzBruttoSumme = 0;
            let gewinnSumme = 0;
            let ruecklagenDeltaSumme = 0;
            let prozentSumme = 0;
            let mindestNettoSumme = 0;
            let monatsstundenSumme = 0;
            let urlaubTageSumme = 0;
            let krankTageSumme = 0;

            for (let i = 0; i < 6; i++) {
                const idx = startIdx + i;
                const month = rawMonths[idx];
                const calc = detailsFull[idx] || {};
                const ts = teamStats?.[idx] || { urlaub: 0, krank: 0 };
                urlaubTageSumme += Number(ts.urlaub) || 0;
                krankTageSumme += Number(ts.krank) || 0;

                const isActive =
                    (month.bedienumsatzBrutto || 0) > 0 ||
                    (month.vkUmsatzBrutto || 0) > 0 ||
                    !!month.abgeschlossen;
                if (!isActive) continue;

                activeMonths += 1;
                umsatzNettoSumme += calc.gesamtNetto || 0;
                umsatzBruttoSumme += calc.gesamtBrutto || 0;
                gewinnSumme += calc.gewinn || 0;
                ruecklagenDeltaSumme += calc.ruecklagenDelta || 0;
                prozentSumme += calc.prozent || 0;
                mindestNettoSumme += calc.mindestNetto || 0;
                monatsstundenSumme += calc.activeMonatsstunden || MONATSSTUNDEN;
            }

            const umsatzNettoAvg = activeMonths > 0 ? umsatzNettoSumme / activeMonths : 0;
            const umsatzBruttoAvg = activeMonths > 0 ? umsatzBruttoSumme / activeMonths : 0;
            const gewinnAvg = activeMonths > 0 ? gewinnSumme / activeMonths : 0;
            const ruecklagenDeltaAvg = activeMonths > 0 ? ruecklagenDeltaSumme / activeMonths : 0;
            const avgProzent = activeMonths > 0 ? prozentSumme / activeMonths : 0;
            const avgMindestNetto = activeMonths > 0 ? mindestNettoSumme / activeMonths : 0;
            const avgStdUmsatz = safeDiv(umsatzBruttoSumme, monatsstundenSumme);
            const umsatzauslastung =
                (auslastungsFaktor / 100) * safeDiv(avgStdUmsatz, korrekterSollStundenUmsatzBrutto);

            return {
                label,
                activeMonths,
                umsatzNettoSumme,
                umsatzNettoAvg,
                umsatzBruttoSumme,
                umsatzBruttoAvg,
                gewinnSumme,
                gewinnAvg,
                ruecklagenDeltaSumme,
                ruecklagenDeltaAvg,
                umsatzauslastung,
                avgProzent,
                urlaubTageSumme,
                krankTageSumme,
                ampel: resolveAmpel(umsatzNettoAvg, avgMindestNetto, activeMonths),
            };
        };

        return { h1: buildHalf('H1', 0), h2: buildHalf('H2', 6) };
    }, [
        gesamtleistungData,
        calculations,
        calcStoreSoll,
        MONATSSTUNDEN,
        mwstFaktor,
        ruecklagenZielFaktor,
        auslastungsFaktor,
        teamStats,
    ]);

    const executeToggleLock = (index: number) => {
        const currentMonth = gesamtleistungData?.[index] || { abgeschlossen: false };
        const targetState = !currentMonth.abgeschlossen;

        if (targetState) {
            const lfData = clientData?.lohnfaktorData || {};
            const baseMindestumsatzNetto = calculationsStore ? calculationsStore.sollumsatz : 0;
            const mindestumsatz1 = lfData.mindestumsatz1 || baseMindestumsatzNetto;
            const mindestumsatz2 = lfData.mindestumsatz2 || baseMindestumsatzNetto;
            const currentBaseMindestumsatz = index < 6 ? mindestumsatz1 : mindestumsatz2;

            const snapshot = {
                mindestumsatzBase: currentBaseMindestumsatz,
                mwstFaktor: mwstFaktor,
                privatentnahme: gesamtUnternehmerlohn,
                monatsstunden: MONATSSTUNDEN,
                ruecklagenZielFaktor: ruecklagenZielFaktor
            };
            updateGesamtleistungMonat(index, 'frozenCalculations', snapshot);
        } else {
            updateGesamtleistungMonat(index, 'frozenCalculations', null);
        }

        updateGesamtleistungMonat(index, 'abgeschlossen', targetState);
    };

    const handleToggleLock = (index: number) => {
        if (index < 6 && hj1LockedForUi) return;
        // Nur Gesamtleistung — kein Einfluss auf Mitarbeiter-Bulk. Passwort einmal bis Seitenwechsel.
        if (festSessionUnlocked) {
            executeToggleLock(index);
            return;
        }
        setPasswordModal({
            isOpen: true, error: '',
            onConfirm: (password) => {
                if (password === FESTMACHEN_PASSWORT) {
                    setFestSessionUnlocked(true);
                    executeToggleLock(index);
                    setPasswordModal({ isOpen: false, onConfirm: () => {}, error: '' });
                } else {
                    setPasswordModal(prev => ({ ...prev, error: 'Falsches Passwort.' }));
                }
            }
        });
    };

    const updateVorjahr = (index: number, field: string, value: number) => {
        const newData = [...vorjahresDaten];
        newData[index] = { ...newData[index], [field]: value };
        newData[index].vorjahrProzent = safeDiv(newData[index].vorjahrWert2, newData[index].vorjahrWert1);
        setVorjahresDaten(newData);
    };

    const handlePasteVJ = (index: number, field: string, e: React.ClipboardEvent) => {
        const pastedText = e.clipboardData.getData('text');
        const lines = pastedText.split(/\r?\n/).map(l => l.trim()).filter(l => l !== "");
        
        if (lines.length > 1) {
            e.preventDefault();
            const newData = [...vorjahresDaten];
            lines.forEach((line, lineIdx) => {
                const targetIdx = index + lineIdx;
                if (targetIdx < 12) {
                    const cleanVal = parseFloat(line.replace(/\./g, '').replace(',', '.'));
                    if (!isNaN(cleanVal)) {
                        newData[targetIdx] = { ...newData[targetIdx], [field]: cleanVal };
                        newData[targetIdx].vorjahrProzent = safeDiv(newData[targetIdx].vorjahrWert2, newData[targetIdx].vorjahrWert1);
                    }
                }
            });
            setVorjahresDaten(newData);
        }
    };

    const handleStartEditVJ = () => {
        if (isEditModeVJ) {
            setIsEditModeVJ(false);
            return;
        }
        if (festSessionUnlocked) {
            setIsEditModeVJ(true);
            return;
        }
        setPasswordModal({
            isOpen: true, error: '',
            onConfirm: (password) => {
                if (password === FESTMACHEN_PASSWORT) {
                    setFestSessionUnlocked(true);
                    setIsEditModeVJ(true);
                    setPasswordModal({ isOpen: false, onConfirm: () => {}, error: '' });
                } else {
                    setPasswordModal(prev => ({ ...prev, error: 'Falsches Passwort.' }));
                }
            }
        });
    };

    const targetMindestumsatzHeader = clientData?.lohnfaktorData?.mindestumsatz2 || (calculationsStore ? calculationsStore.sollumsatz : 0);

    const normalizedMonthsForSalon = useMemo(() => {
        if (!calculations) return [];
        const list: any[] = [];
        monthNames.forEach((n, idx) => {
            const m = gesamtleistungData?.[idx] || { monat: n, bedienumsatzBrutto: 0, vkUmsatzBrutto: 0, abgeschlossen: false };
            const halbjahrKey = idx < 6 ? 'halbjahr1' : 'halbjahr2';
            const innerIdx = idx % 6;
            const calc = calculations[halbjahrKey]?.monatsDetails?.[innerIdx] || {};
            const stats = teamStats?.[idx] || { urlaub: 0, krank: 0 };
            
            list.push({
                monatName: m.monat,
                index: idx,
                bedienumsatzBrutto: m.bedienumsatzBrutto || 0,
                vkUmsatzBrutto: m.vkUmsatzBrutto || 0,
                gesamtBrutto: calc.gesamtBrutto || 0,
                gesamtNetto: calc.gesamtNetto || 0,
                mindestNetto: calc.mindestNetto || 0,
                privatentnahme: calc.activePrivatentnahme !== undefined ? calc.activePrivatentnahme : gesamtUnternehmerlohn,
                isLocked: m.abgeschlossen || false,
                urlaub: stats.urlaub,
                krank: stats.krank
            });
        });
        return list;
    }, [gesamtleistungData, calculations, teamStats, gesamtUnternehmerlohn]);

    const stammdatenSalon = {
        monatsStunden: MONATSSTUNDEN,
        durchschnittlicherUmsatzProTag: calculationsStore?.durchschnittlicherUmsatzProTag || 0,
        arbeitstageProMonat: ARBEITSTAGE_PRO_MONAT,
        teamSize:
            (Array.isArray(personalData) ? personalData.length : 0) +
            (isMultiFounder ? (Array.isArray(partnerData) ? partnerData.length : 1) : 1),
    };

    const teamEffizienzIst = useMemo(() => {
        let totalEff = 0;
        let count = 0;
        
        if (personalData && effectiveMitarbeiterLeistung) {
            personalData.forEach((ma: EmployeeData) => {
                const eff = effectiveMitarbeiterLeistung[ma.id]?.calculatedAvgEfficiency || 0;
                if (eff > 0) {
                    totalEff += eff;
                    count++;
                }
            });
        }

        founderRows.forEach((f) => {
            if (f.metrics?.efficiency > 0) {
                totalEff += f.metrics.efficiency;
                count++;
            }
        });

        return count > 0 ? totalEff / count : 0;
    }, [personalData, effectiveMitarbeiterLeistung, founderRows]);

    return (
        <div id="main-scroll-container" className="relative w-full min-h-[calc(100vh-160px)] h-auto overflow-visible bg-deep-space selection:bg-phantom-gold selection:text-black pb-28">
            <DashboardStyles />

            <div
                className="flex flex-col font-sans relative bg-pe-bg dark:bg-[#030303] text-pe-text pb-32"
                style={{ width: 'max-content', minWidth: '100%', paddingRight: '2rem' }}
            >
                 <SafePasswordPrompt 
                    isOpen={passwordModal.isOpen} 
                    onClose={() => setPasswordModal({ isOpen: false, onConfirm: () => {}, error: '' })} 
                    onConfirm={(pw: string) => passwordModal.onConfirm(pw)} 
                 />
                 {festSessionUnlocked && (
                    <div className="px-4 sm:px-6 lg:px-8 pt-2 text-[10px] font-bold uppercase tracking-widest text-emerald-400/90">
                        Festsetzen freigeschaltet — Passwort gilt bis zum Verlassen dieser Seite
                    </div>
                 )}
                 <main className="flex-grow p-4 sm:p-6 lg:p-8 relative" style={{ minWidth: 'max-content' }}>
                     
                     <div className="sticky top-0 md:top-28 z-30 flex flex-col sm:flex-row sm:flex-wrap items-start sm:items-center gap-4 mb-6 carbon-weave-bg border border-pe-border dark:border-[#2a2a2a] p-5 rounded-xl w-fit max-w-full bg-pe-card dark:bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg">
                         <div>
                             <h2 className="text-xl font-black tracking-tight text-pe-text uppercase drop-shadow-md">Salon Performance Analyse</h2>
                             <p className="text-[11px] uppercase tracking-widest text-phantom-gold/70 font-bold mt-1">Aggregierte ROI- und Rentabilitäts-Auswertung für das Gesamtunternehmen</p>
                         </div>
                         <button
                             type="button"
                             onClick={() => setIsSummaryOpen(true)}
                             title="Salon-Zeugnis öffnen"
                             data-tooltip-id="app-tooltip"
                             data-tooltip-content="Salon-Zeugnis: Status, Ziele und Maßnahmen für das Gesamtunternehmen."
                             className="shrink-0 bg-[#E6C299]/15 hover:bg-[#E6C299]/25 text-[#E6C299] font-bold py-2.5 px-5 rounded-xl transition-all flex items-center justify-center gap-2 border border-[#E6C299]/50 shadow-lg"
                         >
                             <span aria-hidden>📋</span>
                             Übersicht
                         </button>
                         <button
                             type="button"
                             onClick={() => setIsComparisonOpen(true)}
                             title="Halbjahres-Vergleich öffnen"
                             data-tooltip-id="app-tooltip"
                             data-tooltip-content="H1 vs. H2: Umsatz, Ergebnis, Auslastung und Zielerreichung im Vergleich."
                             className="shrink-0 bg-[#E6C299]/15 hover:bg-[#E6C299]/25 text-[#E6C299] font-bold py-2.5 px-5 rounded-xl transition-all flex items-center justify-center gap-2 border border-[#E6C299]/50 shadow-lg"
                         >
                             <span aria-hidden>⚖️</span>
                             Halbjahres-Vergleich
                         </button>
                     </div>

                     {calculationsStore?.activeLand === 'CH' &&
                         Number(calculationsStore?.mwstSatz) === 0 &&
                         (targetMindestumsatzHeader * (1 + (ruecklagenZielFaktor || 0)) * 12) >=
                             (Number((calculationsStore as any)?.chVatStatus?.vatThreshold) || 100000) && (
                             <div className="mb-6 max-w-6xl w-full bg-[#15171e] border border-[#dcb68a]/50 rounded-xl p-4 shadow-xl flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                                 <div className="flex items-start gap-3">
                                     <span className="inline-flex items-center px-2.5 py-1 rounded-md text-[10px] font-black uppercase tracking-widest bg-[#dcb68a]/20 text-[#dcb68a] border border-[#dcb68a]/50 shrink-0 mt-0.5">
                                         CH · ART. 10 MWSTG
                                     </span>
                                     <div>
                                         <p className="text-xs sm:text-sm font-bold text-white">
                                             Zielumsatz erreicht 100&apos;000 CHF: Gesetzliche MWST-Pflicht entsteht. Jetzt auf 8,1 % MWST umstellen?
                                         </p>
                                         <p className="text-[11px] text-slate-400 mt-0.5">
                                             Geplanter Jahres-Zielumsatz ({Math.round(targetMindestumsatzHeader * (1 + (ruecklagenZielFaktor || 0)) * 12).toLocaleString('de-CH')} CHF) erreicht die Schwelle von 100&apos;000 CHF.
                                         </p>
                                     </div>
                                 </div>
                                 <button
                                     type="button"
                                     onClick={() => {
                                         if (typeof captureState === 'function') captureState();
                                         const prevOverrides = settings?.countryOverrides || {};
                                         const prevCh = prevOverrides.CH || {};
                                         if (typeof updateSettings === 'function') {
                                             updateSettings('countryOverrides', {
                                                 ...prevOverrides,
                                                 CH: {
                                                     ...prevCh,
                                                     isVatExempt: false,
                                                     voluntaryOption: true,
                                                 },
                                             });
                                         }
                                         if (typeof setClientData === 'function') {
                                             setClientData({
                                                 umsatzsteuerbefreit: false,
                                                 isVatExempt: false,
                                             });
                                         }
                                     }}
                                     className="shrink-0 bg-[#dcb68a] hover:bg-[#c9a375] text-[#08090b] font-black text-xs uppercase tracking-widest px-4 py-2.5 rounded-lg transition-all shadow-md"
                                 >
                                     Auf 8,1 % MWST umstellen
                                 </button>
                             </div>
                         )}

                     <PlanzieleSektion 
                        calculations={calculations} 
                        planStunden={gesamtleistungSettings?.planStundenTag || 8} 
                        setPlanStunden={(v) => updateGesamtleistungSetting && updateGesamtleistungSetting('planStundenTag', v)} 
                        monatsStunden={MONATSSTUNDEN} 
                        arbeitstageProMonat={ARBEITSTAGE_PRO_MONAT} 
                        auslastungsFaktor={auslastungsFaktor} 
                        ruecklagenZielFaktor={ruecklagenZielFaktor} 
                        umsatzauslastung={calculations?.gesamtjahr?.umsatzauslastung || 0} 
                        currencyCode={currencyCode} 
                        mwstFaktor={mwstFaktor} 
                        targetMindestumsatz={targetMindestumsatzHeader} 
                        hatVorjahresdaten={hatVorjahresdaten} 
                        setHatVorjahresdaten={setHatVorjahresdaten}
                        isSolo={isSoloActive}
                        soloUrlaub={clientData?.soloVacationDays || 0}
                        onUpdateSoloUrlaub={(v) => setClientData && setClientData({ soloVacationDays: v })}
                        onStartEditVJ={handleStartEditVJ}
                        isEditModeVJ={isEditModeVJ}
                     />
                     
                     <div className="mt-12 relative z-20 w-full">
                        <Hj1MandantLockBanner show={hj1ClientLocked} />
                        <MonatsTabelle 
                            data={gesamtleistungData || []} 
                            updateMonth={updateGesamtleistungMonat} 
                            calculations={calculations} 
                            showFormulas={showFormulas || false} 
                            onToggleLock={handleToggleLock} 
                            hatVorjahresdaten={hatVorjahresdaten}
                            setHatVorjahresdaten={setHatVorjahresdaten}
                            privatentnahme={gesamtUnternehmerlohn} 
                            ruecklagenZielFaktor={ruecklagenZielFaktor} 
                            monatsStunden={MONATSSTUNDEN} 
                            auslastungsFaktor={auslastungsFaktor} 
                            currencyCode={currencyCode} 
                            mwstFaktor={mwstFaktor} 
                            teamStats={teamStats} 
                            vorjahresDaten={vorjahresDaten}
                            updateVorjahr={updateVorjahr}
                            isEditModeVJ={isEditModeVJ}
                            onPasteVJ={handlePasteVJ}
                            isHj1InputLocked={hj1LockedForUi}
                        />
                     </div>
                     
                     <div className="mt-8 flex flex-col lg:flex-row items-start gap-4 w-full max-w-6xl relative z-10 pr-24">
                         
                         {showTeamData && (
                             <div className="flex flex-col gap-4 flex-1 w-full lg:w-auto"> 
                                 <MitarbeiterTabelle 
                                     personalData={personalData} 
                                     liveCalculatedLeistung={effectiveMitarbeiterLeistung} 
                                     isHJ2Freigegeben={isHJ2Freigegeben || false} 
                                     founderRows={founderRows} 
                                 />

                                 <TeamBonusPreviewPanel currencySymbol={currencyCode === 'CHF' ? 'CHF' : '€'} showIndividual className="max-w-3xl pr-4" />
                                 
                                 <UrlaubsverlustRechner 
                                    data={urlaubsverlustData || []} 
                                    onUpdate={updateUrlaubsverlustMonat || (() => {})} 
                                    umsatzProTag={calculationsStore?.durchschnittlicherUmsatzProTag || 0} 
                                    auslastungsFaktor={auslastungsFaktor} 
                                    showFormulas={showFormulas || false} 
                                    ruecklagenZielFaktor={ruecklagenZielFaktor} 
                                    currencyCode={currencyCode} 
                                />
                             </div>
                         )}

                         <div className={`w-full flex-shrink-0 flex flex-col gap-4 ${!showTeamData ? 'max-w-md' : 'lg:w-[450px]'}`}>
                             <LeistungsFeedbackBox prozent={calculations?.gesamtjahr?.average?.prozent || 0} gewinn={calculations?.gesamtjahr?.average?.gewinn || 0} ruecklagenZielFaktor={ruecklagenZielFaktor} />
                             <RealRentabilitaetCard 
                                 rentabilitaet={calculationsStore?.rentabilitaetIst || 0} 
                                 inhaberErtrag={calculationsStore?.inhaberErtragIst || 0} 
                                 istUmsatzNetto={calculationsStore?.durchschnittsUmsatzIstNetto || 0}
                                 currency={currencyCode}
                                 gehalt={gesamtUnternehmerlohn} 
                                 ueberschussProzent={calculationsStore?.ueberschussProzent || 0} 
                             />
                         </div>
                     </div>

                 </main>
                 <div className="h-4 w-36" aria-hidden />
            </div>

            <ExecutiveSummaryModalGesamt 
                isOpen={isSummaryOpen} 
                onClose={() => setIsSummaryOpen(false)} 
                title={clientData?.unternehmername || 'Gesamtunternehmen'}
                currencyCode={currencyCode}
                mwstFaktor={mwstFaktor}
                auslastungsVorgabe={auslastungsFaktor}
                ruecklagenZielFaktor={ruecklagenZielFaktor}
                stammdaten={stammdatenSalon}
                rawMonthsData={normalizedMonthsForSalon}
                isHJ2Freigegeben={isHJ2Freigegeben || false}
                rentabilitaetIst={calculationsStore?.rentabilitaetIst || 0}
                teamEffizienzIst={teamEffizienzIst} 
            />

            <H1H2ComparisonModal
                isOpen={isComparisonOpen}
                onClose={() => setIsComparisonOpen(false)}
                currencyCode={currencyCode}
                ruecklagenZielFaktor={ruecklagenZielFaktor}
                h1={h1h2Comparison.h1}
                h2={h1h2Comparison.h2}
            />

        </div>
    );
};

export default GesamtleistungSeite;